export default {
  spanish: 'Spanisch',
  english: 'Englisch',
  addPrinter: {
    title: "Drucker hinzufügen",
    detectPrinters: "Drucker automatisch erkennen",
    printerName: "Druckername",
    printerType: "Druckertyp",
    laser: "Laserdrucker",
    receipt: "Kassendrucker",
    barcode: "Barcode-Drucker",
    connectionType: "Verbindungstyp",
    network: "Netzwerk",
    ipAddress: "IP-Adresse",
    port: "Port",
    driverType: "Treibertyp",
    printSpeed: "Druckgeschwindigkeit",
    autoCutter: "Automatischer Papierschneider",
    cashDrawerPort: "Kassenladen-Anschluss",
    printDensity: "Druckdichte",
    savePrinter: "Drucker speichern",
    detectionCompleted: "Druckererfassung abgeschlossen.",
    fillAllFields: "Bitte füllen Sie alle erforderlichen Felder aus.",
    success: "Drucker wurde erfolgreich hinzugefügt!",
    scanning: "Suche nach Druckern...",
    detectionSuccess: "Drucker erfolgreich erkannt!",
    noPrintersFound: "Keine Drucker gefunden.",
    detectionError: "Fehler bei der Druckererfassung."
  },
  // Weitere Übersetzungen können hier hinzugefügt werden
  backoffice:{
    printerManager: {
      title: "Druckerverwaltung",
      printers: "Drucker",
      select: "Auswählen",
      discoverPrinters: "Drucker suchen",
      showAddPrinter: "Drucker hinzufügen",
      printTest: "Testseite drucken",
      scanBluetooth: "Bluetooth-Drucker suchen",
      printerName: "Druckername",
      printerType: "Druckertyp",
      laser: "Laserdrucker (A4)",
      receipt: "Belegdrucker",
      barcode: "Barcode-Drucker",
      autoCutter: "Automatischer Schneider",
      driverType: "Treiber-Typ",
      connectionType: "Verbindungstyp",
      ipAddress: "IP-Adresse",
      port: "Port",
      mac: "MAC-Adresse",
      isDefault: "Standard",
      add: "Hinzufügen",
      cancel: "Abbrechen",
      noPrintersFound: "Keine Drucker gefunden.",
      printSentSuccess: "Druckauftrag erfolgreich an Netzwerkdrucker gesendet.",
      printFailedBackend: "Druckauftrag im Backend fehlgeschlagen.",
      networkPrintError: "Netzwerkdruckfehler: {error}",
      usbPrintError: "USB-Druckfehler. Verbindungen prüfen!",
      noUSBPrinters: "Keine USB-Drucker erkannt!",
      bluetoothPrintError: "Bluetooth-Druckfehler: Verbindung prüfen!",
      printFailed: "Drucken fehlgeschlagen. Bitte Druckerverbindung prüfen und erneut versuchen.",
      selectPrinterType: "Auswählen Printer Connection Type",
      inputPlaceholder: "Auswählen a type connection",
      pleaseSelectPrinterType: "Bitte wählen Sie einen Druckertyp.",
      invalidPrinterType: "Ungültiger Druckertyp ausgewählt.",
      scannedFromBLE: "Von BLE gescannt: {barcode}"
    },
    bleScanner: {
      title: "BLE-Scanner und -Drucker",
      deviceType: "Gerätetyp",
      scanner: "Barcodescanner",
      printer: "Drucker",
      scanDevices: "Nach BLE-Geräten suchen",
      unnamedDevice: "Unbenanntes Gerät",
      connect: "Verbinden",
      scannedBarcode: "Gescanntes Barcode:",
      printData: "Druckdaten",
      enterPrintText: "Text zum Drucken eingeben",
      sendToPrinter: "An Drucker senden",
      bleScanError: "BLE-Scan-Fehler: {error}",
      connectionSuccess: "Verbunden mit {device}",
      connectionError: "Verbindungsfehler: {error}",
      notificationError: "Benachrichtigungsfehler: {error}",
      scanned: "Gescannt: {barcode}",
      noPrinterOrData: "Kein Drucker verbunden oder Druckdaten leer.",
      printDataSent: "Druckdaten an Drucker gesendet.",
      printError: "Druckfehler: {error}"
    },
    interactions: {
      lastContacted: 'Letzter Kontakt',
      notesLastContacted: 'Notizen Letzter Kontakt',
      nextFollowUp: 'Nächster Folge',
      notesNextFollowUp: 'Notizen Nächster Folge',
      preferredContactTime: 'Bevorzugte Kontaktzeit',
      notesContactToTime: 'Notizen Bevorzugte Kontaktzeit',
      selectSubscriber: 'Abonnent auswählen',
      selectSubscriberDescription: 'Wählen Sie einen Abonnenten aus, um eine oder mehrere Abonnenten hinzuzufügen oder um die Informationen des Abonnenten anzuzeigen.',
      selectSubscriberInput: 'Wählen Sie einen Abonnenten aus',
      selectSubscriberInputPlaceholder: 'Wählen Sie einen Abonnenten aus',
      createSubscriber: 'Abonnent erstellen',
      cancel: 'Abbrechen',
      //customers
      selectCustomer: 'Kunde auswählen',
      selectCustomerDescription: 'Wählen Sie einen Kunde aus, um eine oder mehrere Kunden hinzuzufügen oder um die Informationen des Kunden anzuzeigen.',
      selectCustomerInput: 'Wählen Sie einen Kunde aus',
      selectCustomerInputPlaceholder: 'Wählen Sie einen Kunde aus',
      createCustomer: 'Kunde erstellen',
    },
    cCardSaved:{
      paymentManagement: 'Zahlungsverwaltung',
      clickToManageCards: 'Klicken Sie hier, um Ihre gespeicherten Karten hinzuzufügen oder anzuzeigen',
      creditCards: 'Kreditkarten',
      addCreditCard: 'Kreditkarte hinzufügen',
    },
    virtualTerminal: {
      acordeon1: {
        title: 'Zahlungs-/Autorisierungsinformationen',
        subtitle: 'Zahlungsmethode akzeptieren: American Express, Discover, Mastercard',
        cardNumber: 'Kartennummer',
        expirationDate: 'Ablaufdatum',
        amount: 'Betrag'
      },
      acordeon2: {
        title: 'Bestellinformationen',
        subscriptionName: 'Abonnementname',
        invoice: 'Rechnung #',
        description: 'Beschreibung',
        placeholder: 'Geben Sie hier weitere Informationen ein...'
      },
      acordeon3: {
        title: 'Abonnementintervall',
        subtitle: 'Wählen Sie, wie oft der Kunde abgerechnet werden soll.',
        selectOption: 'Option auswählen',
        interval1: 'Monatlich',
        interval2: 'Vierteljährlich',
        interval3: 'Halbjährlich',
        interval4: 'Jährlich'
      },
      acordeon4: {
        title: 'Abonnementdauer',
        startDate: 'Startdatum',
        noEnd: 'Kein Enddatum (laufendes Abonnement)',
        endDate: 'Enddatum',
        endAfter: 'Ende nach'
      },
      acordeon5: {
        title: 'Zahlung',
        nameAcount: 'Name auf dem Konto',
        paymentType: 'Zahlungsart',
        creditCard: 'Kreditkarte',
        subscriptionName: 'Abonnementname',
        trialAmount: 'Testbetrag',
        firstName: 'Vorname',
        sameAsBilling: 'Wie Rechnungsadresse'
      }
    },
    worksheetStatus: {
      draft: 'Entwurf',
      opened: 'Geöffnet',
      closed: 'Geschlossen',
      worksheetDetail: 'Arbeitsblattdetails',
      fields: {
        responsable: 'Verantwortlich',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        workers: 'Mitarbeiter'
      },
      tooltip: {
        staffWorker: 'Mitarbeiter hinzufügen',
        resetAllCalendar: 'Alle Kalender zurücksetzen',
        showCalendarDetails: 'Kalenderdetails anzeigen',
        resetCalendar: 'Diesen Kalender zurücksetzen',
        removeStaffWorker: 'Mitarbeiter entfernen',
        debit: 'Das sind Ihre Ausgaben. Geld, das ausgezahlt wird.',
        credit: 'Das sind Ihre Einnahmen. Geld, das Ihnen zufließt.',
        payee: 'Das ist die Person, die Sie bezahlt hat oder die Sie bezahlt haben.',
        category: 'Dies ist die Art der Zahlung oder Gutschrift.',
        bestRepresentation: 'Dies ist die beste Kategorie-Vermutung des Systems.'
      },
      message: {
        totalHour: 'Gesamtarbeitszeit:',
        hours: 'Stunden',
        with: 'mit',
        minutes: 'Minuten',
        typeMessage: 'Nachricht hier eingeben...'
      },
      button: {
        saveDraft: 'Entwurf speichern',
        saveOpen: 'Speichern und öffnen',
        close: 'Schließen',
        addShift: 'Schicht hinzufügen',
        changeworksheetRequest: 'Änderungsanfrage'
      }
    },
    mastercard: {
      accountInfo: 'Kontoinformationen',
      mastercardUserDetails: 'Mastercard-Benutzerdetails',
      seeLinedAccounts: 'Verknüpfte Konten anzeigen',
      addMoreBanks: 'Weitere Banken hinzufügen',
      linkedBanks: 'Verknüpfte Konten',
      viewTransactions: 'Transaktionen anzeigen',
      linesPerPage: 'Zeilen pro Seite'
    },
    transactionData: {
      revenue: "Einnahmen",
      revenueDescription: "Schalten Sie diesen Schalter um, wenn es sich um einen Einnahmeeintrag handelt.",
      transactionId: "Transaktions-ID",
      transactionIdDescription: "Geben Sie die eindeutige Transaktions-ID ein, die mit dieser Transaktion verbunden ist.",
      transactionAmount: "Transaktionsbetrag (USD)",
      transactionAmountDescription: "Geben Sie den Transaktionsbetrag in USD ein. Dies ist der Betrag, der in die Transaktion involviert ist.",
      accountId: "Konto-ID",
      accountIdDescription: "Geben Sie die eindeutige Konto-ID ein, die mit der Transaktion verbunden ist.",
      customerId: "Kunden-ID",
      customerIdDescription: "Geben Sie die eindeutige Kunden-ID ein, die mit der Transaktion verbunden ist.",
      transactionStatus: "Transaktionsstatus",
      transactionStatusDescription: "Wählen Sie den aktuellen Status der Transaktion aus den verfügbaren Optionen aus.",
      statusOptions: {
        active: "Aktiv",
        pending: "Ausstehend",
        completed: "Abgeschlossen",
        failed: "Fehlgeschlagen",
        cancelled: "Abgebrochen"
      },
      memo: "Notiz",
      memoDescription: "Geben Sie zusätzliche Notizen oder eine Memo für die Transaktion ein.",
      transactionType: "Transaktionstyp",
      transactionTypeDescription: "Wählen Sie den Transaktionstyp für diese Transaktion aus.",
      transactionDate: "Transaktionsdatum",
      transactionDateDescription: "Wählen Sie das Datum aus, an dem die Transaktion stattgefunden hat.",
      typeOptions: {
        debit: "Lastschrift",
        credit: "Gutschrift",
        transfer: "Überweisung",
        payment: "Zahlung",
        withdrawal: "Abhebung",
        deposit: "Einzahlung"
      },
      postedDate: "Buchungsdatum",
      postedDateDescription: "Wählen Sie das Datum aus, an dem die Transaktion gebucht wurde.",
      createdDate: "Erstellungsdatum",
      createdDateDescription: "Wählen Sie das Datum aus, an dem die Transaktion erstellt wurde.",
      firstEffectiveDate: "Erstes Effektivdatum",
      firstEffectiveDateDescription: "Wählen Sie das erste Effektivdatum für die Transaktion aus.",
      effectiveDate: "Effektivdatum",
      effectiveDateDescription: "Wählen Sie das Effektivdatum für die Transaktion aus.",
      optionExpireDate: "Optionsverfallsdatum",
      optionExpireDateDescription: "Wählen Sie das Optionsverfallsdatum aus, falls zutreffend.",
      checkNumber: "Schecknummer",
      checkNumberDescription: "Geben Sie die Schecknummer ein, falls zutreffend. Leer lassen, falls nicht zutreffend.",
      escrowAmount: "Treuhandbetrag (USD)",
      escrowAmountDescription: "Geben Sie den Treuhandbetrag ein, falls zutreffend. Dies ist der Betrag, der für die Transaktion treuhänderisch gehalten wird.",
      transactionFeeAmount: "Transaktionsgebühr (USD)",
      transactionFeeAmountDescription: "Geben Sie den Gebührenbetrag ein, falls zutreffend. Dies ist die Gebühr für die Abwicklung der Transaktion.",
      suspenseAmount: "Schwebebetrag (USD)",
      suspenseAmountDescription: "Geben Sie den Schwebebetrag ein, falls zutreffend. Dieser wird für Transaktionen verwendet, die vorübergehend zurückgehalten oder ausstehend sind.",
      interestAmount: "Zinsbetrag (USD)",
      interestAmountDescription: "Geben Sie den Zinsbetrag ein, falls zutreffend. Dies ist der Betrag der aufgelaufenen Zinsen für die Transaktion.",
      principalAmount: "Kapitalbetrag (USD)",
      principalAmountDescription: "Geben Sie den Kapitalbetrag ein, falls zutreffend. Dies ist der ursprüngliche Geldbetrag, der geliehen oder investiert wurde, ohne Zinsen oder Gebühren.",
      optionStrikePrice: "Optionsbasispreis (USD)",
      optionStrikePriceDescription: "Geben Sie den Optionsbasispreis ein, falls zutreffend. Dies ist der Preis, zu dem die Option ausgeübt werden kann.",
      unitQuantity: "Mengeneinheit",
      unitQuantityDescription: "Geben Sie die Mengeneinheit ein, falls zutreffend. Dies ist die Anzahl der in die Transaktion involvierten Einheiten, wie z.B. gekaufte Artikel oder gehandelte Aktien.",
      unitPrice: "Stückpreis (USD)",
      unitPriceDescription: "Geben Sie den Stückpreis ein, falls zutreffend. Dies wird für Transaktionen mit Wertpapieren oder Investitionen verwendet.",
      transactionCategorization: "Transaktionskategorisierung",
      normalizedPayeeName: "Normalisierter Zahlungsempfängername",
      normalizedPayeeNameDescription: "Geben Sie den Namen des Zahlungsempfängers in einem standardisierten Format ein. Dies ist nützlich, um die Konsistenz in den Aufzeichnungen zu gewährleisten.",
      transactionCategory: "Transaktionskategorie",
      transactionCategoryDescription: "Geben Sie die Kategorie der Transaktion ein, wie z.B. 'Verkauf', 'Kauf' oder 'Überweisung'.",
      customCategory: "Benutzerdefinierte Kategorie",
      customCategoryDescription: "Geben Sie eine benutzerdefinierte Kategorie ein, falls zutreffend. Dies ist für Transaktionen, die nicht in vordefinierte Kategorien passen.",
      city: "Stadt",
      cityDescription: "Geben Sie die Stadt ein, die mit der Transaktion verbunden ist.",
      state: "Bundesland",
      stateDescription: "Geben Sie das Bundesland oder die Region ein, in der die Transaktion stattgefunden hat.",
      postalCode: "Postleitzahl",
      postalCodeDescription: "Geben Sie die Postleitzahl des mit der Transaktion verbundenen Standorts ein.",
      country: "Land",
      countryDescription: "Geben Sie das Land ein, in dem die Transaktion stattgefunden hat.",
      bestRepresentation: "Beste Darstellung",
      bestRepresentationDescription: "Geben Sie die beste Darstellung für die Transaktion ein, die eine allgemeine Beschreibung oder Klassifizierung sein könnte.",
      runningBalanceAmountUSD: "Laufender Saldo (USD)",
      runningBalanceAmountUSDDescription: "Geben Sie den laufenden Saldo in USD ein, der der fortlaufende Saldo nach der Abwicklung der Transaktion ist.",
      subaccountSecurityType: "Unterkonto-Sicherheitstyp",
      subaccountSecurityTypeDescription: "Geben Sie den mit dem Unterkonto verbundenen Sicherheitstyp ein, falls zutreffend.",
      commissionAmountUSD: "Provisionbetrag (USD)",
      commissionAmountUSDDescription: "Geben Sie den Provisionbetrag in USD ein, falls zutreffend. Dies ist die Gebühr, die für die Transaktion berechnet wird.",
      tickerSymbol: "Tickersymbol",
      tickerSymbolDescription: "Geben Sie das Tickersymbol für den Vermögenswert oder das Wertpapier ein, das in die Transaktion involviert ist.",
      investmentTransactionType: "Investitionstransaktionstyp",
      investmentTransactionTypeDescription: "Geben Sie den Typ der Investitionstransaktion ein, wie z.B. 'Kauf', 'Verkauf' oder 'Dividende'.",
      taxesAmountUSD: "Steuerbetrag (USD)",
      taxesAmountUSDDescription: "Geben Sie den mit der Transaktion verbundenen Steuerbetrag in USD ein.",
      currencySymbol: "Währungssymbol",
      currencySymbolDescription: "Geben Sie das Symbol der in der Transaktion verwendeten Währung ein, wie z.B. '$' für USD oder '€' für EUR.",
      incomeType: "Einkommenstyp",
      incomeTypeDescription: "Geben Sie den Typ des Einkommens ein, wie z.B. 'Lohn', 'Zinsen' oder 'Kapitalgewinne'.",
      splitDenominator: "Split-Nenner",
      splitDenominatorDescription: "Geben Sie den Nenner für gebrochene oder geteilte Transaktionen ein, falls zutreffend.",
      splitNumerator: "Split-Zähler",
      splitNumeratorDescription: "Geben Sie den Split-Zähler ein, falls zutreffend. Dieser Wert wird für Transaktionen verwendet, die eine Aufteilung von Beträgen über mehrere Kategorien oder Konten beinhalten.",
      sharesPerContract: "Aktien pro Vertrag",
      sharesPerContractDescription: "Geben Sie die Anzahl der Aktien pro Vertrag ein, falls zutreffend. Dies ist relevant für Investitionstransaktionen oder Verträge, die Aktien beinhalten.",
      subAccountFund: "Unterkontofonds",
      subAccountFundDescription: "Geben Sie den Unterkontofonds ein, falls zutreffend.",
      securityId: "Sicherheits-ID",
      securityIdDescription: "Geben Sie die Sicherheits-ID ein, falls zutreffend.",
      securityIdType: "Sicherheits-ID-Typ",
      securityIdTypeDescription: "Geben Sie den Sicherheits-ID-Typ ein, falls zutreffend.",
      saveTransaction: "Transaktion speichern"
    },
    multiActionText: {
      selectAll: 'Alle auswählen',
      deselectAll: 'Auswahl aufheben',
      deleteSelected: 'Ausgewählte löschen',
    },
    communicationResponse: {
      failedToLoad: 'Laden fehlgeschlagen',
      emailError: 'E-Mail-Antworten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.',
      smsError: 'SMS-Antworten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.',
    },
    interactionHistory: {
      historyInteraction: "Interaktionsverlauf",
      lastContacted: "Zuletzt kontaktiert",
      notesLastContacted: "Notiz",
      nextFollowUp: "Nächste Nachverfolgung",
      notesNextFollowUp: "Notiz",
      preferredContactTime: "Bevorzugte Kontaktzeit",
      preferredContactToTime: "Bis",
      notesContactToTime: "Notiz",
      noHistory: "Kein Verlauf vorhanden"
    },    
    imenuPayFlex:{
      invoiceId: "Rechnungs-ID",
      planName: "Tarifname",
      amount: "Betrag",
      totalAmount: "Gesamtbetrag",
      subscription: "Abonnement",
      schedulePayment: "Zahlungsplan",
      recurringPayment: "Wiederkehrende Zahlung?",
      frequency: "Häufigkeit",
      payEvery: "Zahlung alle",
      customInterval: "Benutzerdefiniertes Intervall",
      customIntervalNote: "Zahlung erfolgt alle {days} Tage",
      payStartsOn: "Zahlung beginnt am",
      payUntil: "Zahlung bis",
      endsAfterDate: "Zahlung endet nach Datum",
      endsAfterOccurrences: "Zahlung endet nach {count} Vorkommen",
      howToPay: "Wie möchten Sie bezahlen?",
      creditCard: "Kreditkarte",
      banking: "Banküberweisung",
      placeholderCustomInterval: "2",
      placeholderOccurrences: "Beispiel: 2",
    },
    googleCalendar: {
      createEvent: "Termin erstellen",
      title: "Titel",
      description: "Beschreibung",
      location: "Ort",
      startTime: "Startzeit",
      endTime: "Endzeit",
      timeZone: "Zeitzone",
      selectTimeZone: "Zeitzone auswählen",
      attendeeEmail: "Teilnehmer-E-Mail",
      attendeeEmailPlaceholder: "kunde@beispiel.com",
      attendeeEmailLabel: "Teilnehmer-E-Mail",
      addAttendee: "Teilnehmer hinzufügen",
      providerEmail: "Anbieter-E-Mail",
      providerEmailPlaceholder: "anbieter@beispiel.com",
      color: "Farbe",
      selectColor: "Farbe auswählen",
      submitEvent: "Termin erstellen",
      updateEvent: "Termin aktualisieren",
      upcomingEvents: "Bevorstehende Termine",
      deleteConfirmationTitle: "Sind Sie sicher?",
      deleteConfirmationText: "Diese Aktion kann nicht rückgängig gemacht werden!",
      deleteNotificationCheckbox: "Möchten Sie die Teilnehmer über die Stornierung informieren?",
      deleteConfirmButton: "Ja, löschen!",
      deleteCancelButton: "Abbrechen",
      deleteSuccessTitle: "Gelöscht!",
      deleteSuccessText: "Der Termin wurde erfolgreich gelöscht.",
      deleteErrorTitle: "Fehler!",
      deleteErrorText: "Der Termin konnte nicht gelöscht werden."
    },        
    bulkSend: {
      title: "Was ist Massenversand?",
      text: "Der Massenversand ermöglicht es Ihnen, mehrere E-Mails und SMS-Nachrichten gleichzeitig zu versenden, was die Kommunikation effizienter macht.",
      confirmButtonText: "Verstanden!",
      selectRecipientsTitle: "Empfänger auswählen",
      selectAllCustomers: "Alle Kunden auswählen",
      selectAllSubscribers: "Alle Abonnenten auswählen",
      bulkSendOptionsTitle: "Massenversand-Optionen",
      sendEmail: "Massen-E-Mail versenden",
      sendSMS: "Massen-SMS versenden",
      whenToSend: "Wann soll die Nachricht versendet werden?",
      sendNow: "Jetzt senden",
      schedule: "Planen",
      cancel: "Abbrechen",
      validationSelectMethod: "Bitte wählen Sie mindestens eine Methode aus.",
      validationScheduledTime: "Der geplante Zeitpunkt muss in der Zukunft liegen.",
      successSent: "Erfolgreich versendet!",
      successScheduled: "Erfolgreich geplant!",
      error: "Ein Fehler ist aufgetreten.",
      subject: "Massenbenachrichtigung",
      body: "Ihr geplanter Nachrichteninhalt hier.",
      bulkSend:"Massenversand",
      validationSelectRecipients: "Wählen Sie mindestens einen Empfänger aus"
    },      
    table: {
      transactionDate: 'Transaktionsdatum',
      customerId: 'Kunden-ID',
      status: 'Status',
      debit: 'Lastschrift',
      credit: 'Gutschrift',
      description: 'Beschreibung',
      memo: 'Notiz',
      payee: 'Zahlungsempfänger',
      category: 'Kategorie',
      bestRepresentation: 'Beste Darstellung',
      country: 'Land',
      action: 'Aktion'
    },
    emailTest: {
      sendTest: 'Test-E-Mail senden',
      message: "Dies ist eine Beispielnachricht. Bitte antworten Sie nicht auf diese Nachricht.",
      subject: 'iMenuApps® Support.',
      success: 'E-Mail wurde erfolgreich versendet.'
    },
    menu: {
      titleQuoteConverted: 'Angebotsanforderung konvertiert in Rechnung',
      quoteConverted: 'Angebotsanforderung wurde erfolgreich in Rechnung konvertiert.',
      transactionData: 'Transaktionsdaten',
      bankAccountConnection: 'Bankverbindung',
      viewTransactions: 'Transaktionen anzeigen',
      validationPhone: 'Die Telefonnummer muss genau 10 Ziffern enthalten.',
      restaurantAdministration: 'Admin',
      savedSuccesful: 'Die Einstellung wurde erfolgreich geändert',
      savedFailed: 'Beim Speichern der Einstellungen ist ein Fehler aufgetreten.',
      lostChanges: 'Ihre Änderungen gehen verloren, wenn Sie diese Seite verlassen!',
      sure: 'Sind Sie sicher?',
      wontRevert: "Diese Aktion kann nicht rückgängig gemacht werden!",
      yesVoid: 'Ja, Zahlung stornieren!',
      voided: 'Storniert!',
      voidedSuccessfully: 'Die Zahlung wurde erfolgreich storniert.',
      yesRefund: 'Ja, erstatten!',
      refund: 'Erstattet!',
      refundSuccessfully: 'Die Erstattung wurde erfolgreich bearbeitet.',
      merchantQuoteNotes: 'Händler-Angebotsnotizen',
      merchantInvoiceNotes: 'Händler-Rechnungsnotizen',
      titleInformationIncomplete: 'Erforderliche Informationen',
      informationIncomplete: 'Bitte füllen Sie alle erforderlichen Felder aus.',
      yes: 'Ja',
      emailSend: 'E-Mail gesendet',
      emailSendTo: 'Die E-Mail mit der Rechnung wurde erfolgreich gesendet an',
      questionSendEmail: 'E-Mail senden?',
      dialogSendEmail: 'Möchten Sie wirklich eine E-Mail senden an',
      addNewSendEmail: 'Weitere E-Mail-Adresse hinzufügen',
      send: 'Senden',
      close: 'Schließen',
      alertEmailSend: 'E-Mail gesendet',
      alertEmailSendTo: 'Erfolgreich gesendet an',
      session: 'Sitzung',
      foodServices: 'Produkte/Dienstleistungen',
      ordersTickets: 'Bestellungen/Tickets',
      reservationsDeliveries: 'Reservierungen/Lieferungen',
      restaurantAdministration: 'Verwaltung',
      report: 'Berichte',
      sales: 'Verkäufe',
      staffOccupationsCustomersDrivers: 'Mitarbeiter/Berufe/Kunden/Fahrer',
      marketing: 'Marketing',
      settings: 'Einstellungen',
      merchantSettings: 'Händlereinstellungen',
      revenue: 'Einnahmen',
      revenueInfo:
        'Der Bereich Einnahmen in iMenuApps® ist Ihr zentraler Hub zur Verwaltung aller einkommensgenerierenden Aktivitäten in Ihrem Unternehmen. Dieser Bereich ermöglicht es Ihnen, verschiedene Aufgaben im Zusammenhang mit Einnahmen und finanziellen Transaktionen effizient zu verwalten, um einen reibungslosen und profitablen Betrieb Ihres Unternehmens zu gewährleisten. Hier ist, was Sie im Bereich Einnahmen tun können: 1. Bestellungen anzeigen/erstellen: Verwalten Sie Kundenbestellungen von der Erstellung bis zum Abschluss. Diese Funktion ermöglicht es Ihnen, alle Bestellungen im Blick zu behalten und sicherzustellen, dass sie verarbeitet werden. 2. Reservierungen: Verwalten und verfolgen Sie Reservierungen für Ihre Dienstleistungen, sei es für Speisen, Veranstaltungen oder andere Buchungen. Diese Funktion stellt sicher, dass Sie Ihre Buchungen effektiv verwalten und Überbuchungen vermeiden können. 3. Angebote: Erstellen und verwalten Sie Angebote für potenzielle Einnahmen, sodass Sie Kunden detaillierte Preis- und Serviceinformationen vor dem endgültigen Verkauf bereitstellen können. Akzeptierte Angebote können leicht in Rechnungen umgewandelt werden, um den Einnahmeprozess zu optimieren. 4. Rechnungen: Erstellen, verwalten und verfolgen Sie alle Kundenrechnungen. Diese Funktion gewährleistet eine genaue Abrechnung und bietet einen klaren Überblick über alle Einnahmetransaktionen. 5. Versand: Koordinieren und verwalten Sie Versanddetails für Bestellungen, einschließlich der Vorbereitung, Planung und Versendung von Lieferungen. 6. Lieferungen verfolgen: Überwachen Sie den Status und Fortschritt von Lieferungen in Echtzeit, um sicherzustellen, dass Ihre Lieferungen planmäßig erfolgen und Kunden informiert bleiben. 7. Abonnementabrechnung: Verwalten Sie wiederkehrende Abrechnungen für Abonnementdienstleistungen, um sicherzustellen, dass Kunden für laufende Dienstleistungen korrekt und pünktlich abgerechnet werden. 8. Lieferungen: Überwachen und verwalten Sie alle Lieferaktivitäten, von der Auftragsabwicklung bis zur endgültigen Lieferung an die Kunden, um sicherzustellen, dass Waren und Dienstleistungen effizient an ihr Ziel gelangen. 9. Abholanfragen: Bearbeiten Sie Kundenanfragen zur Abholung von Bestellungen, sodass diese ihre Bestellungen direkt von Ihrem Geschäft abholen können.',
      adminInfo:
        'Der Bereich Verwaltung in iMenuApps® dient als Kontrollzentrum für die Verwaltung verschiedener betrieblicher und logistischer Aspekte Ihres Unternehmens. Hier ist eine Übersicht über die Funktionen und Aufgaben, die Sie in diesem Bereich verwalten können: 1. Tischverwaltung: • Konfigurieren und verwalten Sie die Tischanordnung Ihres Unternehmens, einschließlich der Anzahl der Tische, ihrer Anordnung und Sitzplatzkapazität. • Optimieren Sie den Platz für Reservierungen und sorgen Sie für einen effizienten Tischumsatz. 2. Steuerverwaltung: • Legen Sie die auf Ihre Artikel und Dienstleistungen anwendbaren Steuersätze fest und verwalten Sie diese. • Stellen Sie sicher, dass Steuern gemäß den lokalen Vorschriften korrekt auf alle Transaktionen angewendet werden. 3. Lieferverwaltung: • Überwachen Sie Ihre Liefervorgänge von der Zuweisung bis zum Abschluss. • Verfolgen Sie Bestellungen in Echtzeit und informieren Sie Kunden über den Status ihrer Lieferungen. • Gewährleisten Sie effiziente und pünktliche Lieferungen, um die Kundenzufriedenheit zu steigern. 4. Mitarbeitermanagement: • Verwalten Sie Ihr Team, einschließlich der Einstellung neuer Mitarbeiter, der Aktualisierung von Rollen und der Verwaltung von Berechtigungen. • Richten Sie Rollen ein und weisen Sie Aufgaben zu, um einen reibungslosen Betrieb zu gewährleisten. 5. Fahrermanagement: • Verwalten Sie Ihre Lieferfahrer, weisen Sie Lieferaufgaben zu und verfolgen Sie deren Leistung. • Stellen Sie sicher, dass Ihr Lieferservice reibungslos und effizient läuft. 6. Berechtigungsrollen: • Definieren und verwalten Sie Rollen und Berechtigungen für Mitarbeiter und Administratoren. • Stellen Sie sicher, dass jedes Teammitglied Zugriff auf die Tools und Informationen hat, die es zur effektiven Erfüllung seiner Aufgaben benötigt. 7. Arbeitszeitmanagement: • Verfolgen und verwalten Sie Arbeitszeiten und Zeitpläne der Mitarbeiter. • Gewährleisten Sie eine genaue Zeiterfassung und Gehaltsabrechnung. 8. Berufsmanagement: • Organisieren und verwalten Sie verschiedene Mitarbeiterberufe in Ihrem Unternehmen. • Halten Sie Ihr Team strukturiert und Rollen klar definiert. 9. Kundenmanagement: • Verwalten Sie Kundeninformationen, verfolgen Sie Bestellungen und pflegen Sie Kundenprofile. • Verbessern Sie den Kundenservice, indem Sie alle Kundendaten leicht zugänglich halten. 10. Kreditmanagement: • Verwalten Sie Kundenguthaben effizient, wenden Sie Guthaben auf Bestellungen an und behalten Sie Guthabenstände im Blick. 11. Speisekartenmanagement: • Entwerfen und verwalten Sie Ihre Speisekarten, einschließlich der Erstellung neuer Artikel, Aktualisierungen und Preisverwaltung. 12. Kategorieverwaltung: • Organisieren Sie Ihre Menüpunkte in Kategorien für eine einfachere Navigation und Verwaltung. • Halten Sie Ihre Speisekarten strukturiert und für Kunden leicht durchsuchbar. 13. Produktmanagement: • Verwalten Sie Ihren Produktbestand, einschließlich der Hinzufügung neuer Artikel, Aktualisierungen und Bestandsverwaltung. 14. Barcode-Generator: • Erstellen und verwalten Sie Barcodes für Ihre Produkte, um die Bestandsverwaltung und Verkaufsnachverfolgung zu optimieren. 15. Dienstleistungsmanagement: • Verwalten Sie zusätzliche Dienstleistungen Ihres Restaurants, wie Catering oder Veranstaltungsorganisation. • Behalten Sie Dienstbuchungen im Blick und sorgen Sie für einen reibungslosen Ablauf. 16. Sonstige Gebühren: • Richten Sie zusätzliche Gebühren wie Servicegebühren, Liefergebühren oder Sonderveranstaltungsgebühren ein und verwalten Sie diese. • Stellen Sie sicher, dass alle anfallenden Gebühren korrekt in den Kundenrechnungen ausgewiesen werden. 17. Sonderpreise: • Verwalten und wenden Sie Sonderpreise für Werbeaktionen, Rabatte oder Treueprogramme an. • Bieten Sie wettbewerbsfähige Preise, um Kunden zu gewinnen und zu halten. 18. Abonnentenverwaltung: • Verwalten Sie Ihre Liste von Kundenabonnenten für Newsletter und Werbeaktionen. 19. E-Marketing: • Planen und durchführen Sie E-Mail- und SMS-Marketingkampagnen. • Nutzen Sie Kundendaten, um gezielte Werbung zu schalten und mehr Kunden in Ihr Restaurant zu locken. Dieser Bereich bietet Ihnen alle Tools, die Sie benötigen, um die Betriebsabläufe Ihres Unternehmens effizient zu verwalten, von Mitarbeitern und Kunden bis hin zu Speisekarten und Marketing – alles an einem Ort.',
      imenuBookInfo:
        'Der Bereich iMenuBooks ist Ihr umfassendes Buchhaltungs- und Finanzverwaltungszentrum. Hier können Sie Transaktionen verwalten, Bankkonten verbinden und klare und genaue Aufzeichnungen Ihrer finanziellen Aktivitäten führen. Hier ist, was Sie im Bereich iMenuBooks tun können: 1. Transaktionsdaten: Verwalten und speichern Sie alle Transaktionsdaten Ihres Unternehmens. Diese Funktion ermöglicht es Ihnen, jede finanzielle Transaktion nachzuverfolgen, um sicherzustellen, dass Ihre Aufzeichnungen korrekt und aktuell sind. 2. Bankkonto-Verbindung: Verbinden Sie Ihre Geschäftsbankkonten direkt mit dem iMenuBooks-System. Diese Funktion ermöglicht die automatische Synchronisierung finanzieller Daten, was die Verwaltung von Einnahmen, Ausgaben und Kontoständen erleichtert. 3. Transaktionen anzeigen: Zeigen Sie detaillierte Aufzeichnungen aller über Ihr Unternehmen abgewickelten Finanztransaktionen an. Diese Funktion bietet eine organisierte und durchsuchbare Ansicht Ihres Transaktionsverlaufs, sodass Sie finanzielle Aktivitäten einfach überwachen und prüfen können.',
      reportsInfo:
        'Der Bereich Berichte ist Ihr zentraler Hub für den Zugriff auf und die Analyse der Leistungs- und Finanzdaten Ihres Unternehmens. Dieser Bereich bietet Ihnen verschiedene Tools und Berichte, um fundierte Entscheidungen auf der Grundlage von Echtzeitdaten zu treffen. Hier ist, was Sie im Bereich Berichte tun können: 1. Zahlungen: Verfolgen und überprüfen Sie alle von Kunden getätigten Zahlungen. Diese Funktion bietet eine detaillierte Aufschlüsselung von Zahlungstransaktionen, um Einnahmen zu überwachen und genaue Finanzaufzeichnungen zu gewährleisten. 2. Hauskonto: Verwalten und überprüfen Sie Hauskonten Ihrer Stammkunden. Diese Funktion ermöglicht es Ihnen, Kontostände, Belastungen und Zahlungen zu verfolgen, um sicherzustellen, dass Ihre Hauskonten stets aktuell sind. 3. Einnahmen nach Kunden: Analysieren Sie Einnahmedaten nach einzelnen Kunden segmentiert. Dieser Bericht hilft Ihnen, wichtige Kunden zu identifizieren und deren Kaufverhalten zu verstehen, was gezieltes Marketing und verbesserte Kundenbeziehungen ermöglicht. 4. Einnahmen nach Produkten: Zeigen Sie Einnahmedaten basierend auf bestimmten Produkten an. Dieser Bericht ermöglicht es Ihnen, Ihre meistverkauften Artikel zu identifizieren und die Produktleistung zu verstehen, was bei der Bestandsverwaltung und Produktentwicklung hilft. 5. Dynamischer Bericht: Erstellen Sie benutzerdefinierte Berichte, die auf Ihre spezifischen Geschäftsanforderungen zugeschnitten sind. Diese Funktion ermöglicht es Ihnen, dynamische Berichte durch Auswahl verschiedener Parameter zu erstellen, sodass Sie Ihre Daten aus verschiedenen Perspektiven analysieren können.',
      configInfo:
        'Im Bereich Händlereinstellungen können Sie verschiedene wesentliche Aspekte Ihrer Geschäftsabläufe konfigurieren, um sicherzustellen, dass die Plattform Ihren individuellen Anforderungen und Vorlieben entspricht. Dieser Bereich umfasst folgende Schlüsselbereiche: 1. Allgemeine Einstellungen: • Geschäftsinformationen: Richten Sie Ihre Online-Präsenz ein und aktualisieren Sie sie, einschließlich Name, Adresse, Kontaktdaten, Social-Media-Links und Restaurantwährung. • Online-Präsenz: Verwalten Sie Ihre Website-URL, Standort und Fax-Details. Dies ist entscheidend, damit Kunden Sie leicht finden und kontaktieren können. • Geschäftszeiten: Legen Sie Ihre Öffnungszeiten fest und aktualisieren Sie sie, damit Ihre Kunden wissen, wann Sie verfügbar sind. • Geschäftsbedingungen und Richtlinien: Bearbeiten und verwalten Sie einfach Ihre Nutzungsbedingungen, Datenschutzrichtlinien und andere relevante Richtlinien, um Compliance und Transparenz gegenüber Ihren Kunden zu gewährleisten. • Catering- und Lieferungseinstellungen: Definieren Sie Catering-Zustände, gültige Postleitzahlen und Arten von Catering-Veranstaltungen. Verwalten Sie außerdem Lieferzonen und aktivieren/deaktivieren Sie Funktionen wie Liefergebühren, Geolokalisierung und Sichtbarkeit von Bewertungen. • E-Commerce & Online-Verkäufe: Steuern Sie Funktionen wie Rechnungen mit Verspätungsgebühren, Abholanfragen und Anzahlungen, um reibungslose Online-Transaktionen und Bestellverwaltung zu gewährleisten. 2. Funktionalitäten: Konfigurieren Sie spezifische Funktionalitäten für Catering-Bestellungen und Reservierungen, einschließlich Tischstandortpräferenzen, Kundenreservierungsansichten, Vorauszahlungsoptionen und zeitbasierte Einstellungen. • Rechnungs- und Angebotseinstellungen: Konfigurieren Sie Startnummern und Präfixe für Ihre Rechnungen und Angebote, um ein organisiertes und professionelles Abrechnungssystem zu pflegen. • Bestellverwaltung: Richten Sie Bestellpräfixe, Abholzeiten und andere bestellbezogene Konfigurationen ein, um Ihre Bestellabwicklung zu optimieren. • Trinkgeld-Konfiguration: Verwalten Sie Trinkgeldanforderungen, einschließlich der Festlegung standardmäßiger Trinkgeldprozentsätze, was besonders in Servicebranchen nützlich ist. • Sichtbarkeitseinstellungen: Steuern Sie, ob bestimmte Informationen oder Funktionen für Ihre Kunden sichtbar sind, wie z.B. die Anzeige des Kochs oder anderer Unternehmen. 3. Designtools: • Farbschema: Passen Sie das Farbschema Ihrer App an, einschließlich Primär-, Sekundär- und Tertiärfarben, um es an Ihre Markenidentität anzupassen. • Über uns-Folien: Verwalten Sie die Folien, die in Ihrem "Über uns"-Bereich angezeigt werden, um die einzigartigen Angebote und die Persönlichkeit Ihres Unternehmens zu präsentieren. • Digitale Beschilderung: Richten Sie digitale Beschilderung ein, um wichtige Informationen, Menüs und Werbung in Ihrer App oder an Ihrem physischen Standort anzuzeigen. 4. Backup- und Geräteverwaltung: • Geräteverwaltung: Fügen Sie Geräte hinzu und verwalten Sie sie, die mit Ihrem System verbunden sind, wie z.B. POS-Systeme, Drucker und mehr, um sicherzustellen, dass alles synchronisiert und funktionsfähig ist. • Backup-Optionen: Erstellen Sie Backups Ihrer Daten und Einstellungen, um eine Absicherung bei technischen Problemen zu haben. Sie können Backups herunterladen, vom Portal wiederherstellen oder aus einer Datei wiederherstellen. Diese Einstellungen ermöglichen es Ihnen, Ihr iMenuApps®-Erlebnis an Ihre Geschäftsanforderungen anzupassen, was die Verwaltung der Betriebsabläufe und die Aufrechterhaltung einer konsistenten Markenpräsenz über alle Kundenkontaktpunkte hinweg erleichtert.',
      selections: 'Menüpunkte',
      productManagement: 'Produktverwaltung'
    },
    controlPanel: {
      googleCalendar: 'Google Kalender',
      notificationCenter: 'Benachrichtigungszentrum',
      notificationBell: 'Benachrichtigungsglocke',
      salesByCustomers: 'Verkäufe nach Kunden',
      salesByProducts: 'Verkäufe nach Produkten',
      dynamicReport: 'Dynamischer Bericht',
      events: "Termine erstellen",
      eventTitle: "Termine",
      transactionData: 'Finanztransaktionen hinzufügen und bearbeiten',
      bankConnect: 'Bankkonten und Kreditkartenkonten hinzufügen',
      viewTransaction: 'Transaktionen hinzufügen/bearbeiten/ansehen',
      subscription: 'Abonnements und Abrechnungen anzeigen und erstellen (Virtuelles Terminal)',
      staff: 'Erstellung von Benutzerkonten für Geschäftsmitarbeiter.',
      occupations: 'Verwaltung von Geschäftsberufen. Berufe sind mit Mitarbeitern verknüpft. Jeder Mitarbeiter hat einen bestimmten Beruf.',
      roles: 'Rollenverwaltung. Die Rollen legen die Berechtigungen in den verschiedenen Bereichen der Anwendung fest und sind mit den Mitarbeitern verknüpft. Ein Mitarbeiter kann mehrere Rollen haben.',
      workSheet: 'Arbeitszeitnachweis. Arbeitszeitnachweise ermöglichen die Kontrolle der Arbeitszeiten der Mitarbeiter.',
      customers: 'Zeigt eine Liste der Geschäftskunden an.',
      categories: 'Verwalten Sie die verschiedenen Kategorien der Menüs. Kategorien sind mit Artikeln verknüpft. Ein Artikel gehört zu einer Kategorie.',
      menuItems: 'Verwaltung von Artikeln/Produkten/Dienstleistungen. Ein Menü besteht aus Kategorien, und die Artikel/Produkte/Dienstleistungen sind über die Kategorie, zu der sie gehören, mit dem Menü verknüpft.',
      services: 'Verwaltung von Dienstleistungen. Die Dienstleistungen werden in den Catering-Menüs verwendet.',
      menus: 'Menüverwaltung. Ermöglicht die Verwaltung von Menüs. Ein Menü besteht aus verschiedenen Kategorien.',
      orders: 'Bestellungen anzeigen und erstellen. Hier können Sie Bestellungen anzeigen und erstellen',
      invoices: 'Rechnungen anzeigen und erstellen. Hier können Sie Rechnungen anzeigen und erstellen',
      quotes: 'Angebote anzeigen und erstellen. Hier können Sie Angebote anzeigen und erstellen',
      cateringOrders: 'Ermöglicht die Anzeige von Catering-Bestellungen.',
      orderForDelivery: 'Zeigt eine Liste von Bestellungen an, die bereit sind, an den zugewiesenen Fahrer geliefert zu werden.',
      tickets: 'Ermöglicht die Erstellung und Nachverfolgung von Tickets. Tickets sind Bestellungen, die offen bleiben, während der Kunde weiter konsumiert.',
      otherCharges: 'Ermöglicht die Verwaltung zusätzlicher Gebühren für Produktmengen.',
      taxes: 'Steuerverwaltung. Anzeigen und Erstellen von Verkaufssteuersätzen',
      deliveries: 'Verwaltung von Lieferpreisen. Anzeigen und Erstellen von Lieferpreisen, die dem Kunden berechnet werden',
      reservations: 'Reservierungen und Wartelisten verwalten und erstellen',
      tables: 'Verwaltung der Geschäftskapazitäten. Anzeigen und Erstellen von Reservierungen basierend auf der Kapazität des Geschäfts',
      payments: 'Zeigt die Liste der getätigten Zahlungstransaktionen an.',
      aboutSettings: 'Ermöglicht die Verwaltung des Sliders, der auf der Startseite jedes Geschäfts erscheint.',
      paymentSettings: 'Ermöglicht die Konfiguration des Payment Gateways, das zur Abwicklung von Transaktionen verwendet wird.',
      basicSettings: 'Ermöglicht die Konfiguration der Hauptdaten des Geschäfts: Name, Adresse, Telefon... Diese Informationen erscheinen auf der Startseite jedes Geschäfts.',
      funtionalitiesSettings: 'Ermöglicht die Konfiguration des allgemeinen Betriebs des Geschäfts: Öffnungszeiten, Postleitzahlen, Trinkgelder...',
      colorSettings: 'Ermöglicht die Konfiguration der Farben der Anwendung.',
      systemSettings: 'Ermöglicht die Konfiguration der iMenuApps®-Integration mit Drittanbieteranwendungen.',
      driver: 'Verwaltung externer Fahrer',
      credit: 'Ermöglicht die Kreditverwaltung.'
    },
    options: {
      sameAsBilling: 'Wie Rechnungsadresse',
      contactPerson: 'Kontaktperson',
      email: 'E-Mail',
      aditionalDetails: 'Zusätzliche Details',
      street: 'Straße',
      text: 'Beim Festlegen der Standardadresse ist ein Problem aufgetreten.',
      updateAddress: 'Adresse aktualisiert',
      wrongAddress: 'Beim Aktualisieren der Standardadresse ist ein Fehler aufgetreten',
      billingAddress: 'Rechnungsadresse',
      shippingAddress: 'Lieferadresse',
      placeholderNotes: 'Schreiben Sie hier Ihre Notizen',
      dataRequired: 'Daten erforderlich',
      customerArea: 'Kundenbereich',
      customerName: 'Kundenname',
      customerEmail: 'Kunden-E-Mail',
      customerPhone: 'Kundentelefon',
      customerAddress: 'Kundenadresse',
      terms: 'Bedingungen',
      trackingN: 'Sendungsverfolgung Nr.',
      shippingDate: 'Versanddatum',
      shippingTo: 'Versand an',
      footer: 'Bearbeiten Sie den entsprechenden Footer für Ihr Einnahmenmodul',
      ivoiceDate: 'Rechnungsdatum',
      quoteDate: 'Angebotsdatum',
      subscriptionBilling: 'Abonnementabrechnung',
      driverDeliveries: 'Lieferungen',
      activeDriverOrder: 'Aktive Bestellungen',
      completedDriverOrder: 'Abgeschlossene Bestellungen',
      useDirection: 'Klicken Sie hier, wenn gleich wie Rechnungsadresse',
      menuTitle: 'ADMIN',
      login: 'Anmelden',
      logout: 'Abmelden',
      controlPanel: 'Kontrollpanel',
      adminSettings: 'Admin-Einstellungen',
      supportPanel: 'Support',
      manageMenus: 'Menüs',
      managePyments: 'Zahlungen',
      manageHouseAccount: 'Hauskonto',
      viewOrders: 'Bestellungen anzeigen/erstellen',
      viewQuotes: 'Angebote',
      viewInvoice: 'Rechnungen',
      manageCategories: 'Kategorien',
      manageProducts: 'Artikel',
      manageServices: 'Dienstleistungen',
      manageCustomers: 'Kunden',
      manageCredits: 'Guthaben',
      manageTables: 'Tische',
      manageTaxes: 'Steuern',
      manageShippings: 'Lieferpreise',
      manageOtherCharges: 'Sonstige Gebühren',
      manageUsers: 'Mitarbeiter',
      manageDriver: 'Fahrer',
      manageRoles: 'Rollen/Berechtigungen',
      manageWorkSheet: 'Arbeitszeitnachweis',
      manageBasicSettings: 'Geschäft',
      manageRestaurantSettings: 'Geschäftseinstellungen',
      manageAboutSettings: 'Über uns-Folien',
      manageFunSettings: 'Funktionalitäten',
      manageColourSettings: 'Farben',
      manageDesign: 'Design',
      manageMore: 'Mehr',
      managePaymentSettings: 'Zahlungen',
      manageOccupation: 'Berufe',
      manageKeySettings: 'Externe Systeme',
      supportSettings: 'Support-Einstellungen',
      changeServerId: 'Mitarbeiter-ID ändern',
      serverId: 'Mitarbeitercode',
      manageVariantGroup: 'Auswahlmöglichkeiten',
      manageReservation: 'Reservierungen',
      manageWaitList: 'Warteliste',
      viewCateringOrders: 'Catering-Bestellungen',
      forgotPassword: 'Haben Sie Ihr Passwort vergessen?',
      sendNewPassword: 'Neues Passwort senden',
      serverIdMessage: 'Dies ist der Sicherheitscode, der Ihnen bei der Erstellung Ihres Profils zugewiesen wurde',
      recoveryPassword: 'Passwort wiederherstellen',
      refund: 'Erstattung',
      void: 'Stornieren'
    },
    titles: {
      technology: "Technologie",
      retail: "Einzelhandel",
      healthcare: "Gesundheitswesen",
      finance: "Finanzen",
      retailGeneralMerchandise: "Einzelhandel (Allgemeine Waren)",
      healthcareServices: "Gesundheitsdienstleistungen",
      foodAndBeverage: "Lebensmittel und Getränke (Restaurants, Cafés, Bars)",
      construction: "Bauwesen",
      eCommerce: "E-Commerce",
      informationTechnology: "Informationstechnologie (IT-Dienstleistungen und Softwareentwicklung)",
      realEstate: "Immobilien (Wohn- und Gewerbeimmobilien)",
      transportationLogistics: "Transport und Logistik",
      professionalServices: "Professionelle Dienstleistungen (Beratung, Rechtsberatung, Buchhaltung)",
      manufacturing: "Produktion (Allgemein und Spezialisiert)",
      educationTraining: "Bildungs- und Schulungsdienstleistungen",
      entertainmentMedia: "Unterhaltung und Medien",
      financialServices: "Finanzdienstleistungen (Banken, Investmentfirmen)",
      personalCareServices: "Körperpflegedienstleistungen (Salons, Spas)",
      hospitality: "Gastgewerbe (Hotels, Reisebüros)",
      insuranceAgencies: "Versicherungsagenturen",
      homeImprovementRepair: "Heimwerker- und Reparaturdienste",
      automotiveServices: "Automobildienstleistungen (Reparatur, Autohäuser, Lackierereien)",
      telecommunications: "Telekommunikation",
      nonprofitSocialServices: "Gemeinnützige und soziale Dienste",
      agricultureFarming: "Landwirtschaft",
      pharmaceuticalsBiotechnology: "Pharmazeutika und Biotechnologie",
      energy: "Energie (Erneuerbar und Nicht-Erneuerbar)",
      sportsRecreation: "Sport und Freizeit",
      fitnessWellness: "Fitness und Wellness",
      marketingAdvertising: "Marketing und Werbung",
      eventPlanning: "Eventplanung und -dienstleistungen",
      cleaningServices: "Reinigungsdienste (Privat und Gewerbe)",
      fashionApparel: "Mode und Bekleidung",
      foodProductionProcessing: "Lebensmittelproduktion und -verarbeitung",
      petServices: "Tierdienstleistungen (Pflege, Unterbringung, Tierarzt)",
      artsCrafts: "Kunst und Handwerk (Kreative Dienstleistungen)",
      aerospaceDefense: "Luft- und Raumfahrt sowie Verteidigung",
      environmentalServices: "Umweltdienstleistungen",
      technologyHardwareElectronics: "Technologie-Hardware und Elektronik",
      childcareServices: "Kinderbetreuungsdienste",
      securityServices: "Sicherheitsdienste (Cybersicherheit, physische Sicherheit)",
      publishing: "Verlagswesen (Bücher, Zeitschriften, digitale Medien)",
      transportationEquipmentManufacturing: "Transportmittelherstellung",
      architectureDesign: "Architektur und Design",
      accountingTaxPreparation: "Buchhaltung und Steuerberatung",
      landscapingGardening: "Landschaftsbau und Gartenarbeit",
      beverageProduction: "Getränkeproduktion (Craft-Bier, Wein, Spirituosen)",
      medicalDevicesSupplies: "Medizinische Geräte und Versorgungsmaterialien",
      warehousingStorage: "Lagerung und Aufbewahrung",
      freelancing: "Freiberufliche Tätigkeiten (Schreiben, Grafikdesign, Programmierung)",
      tourismAdventureServices: "Tourismus- und Abenteuerdienstleistungen",
      utilitiesPublicServices: "Versorgungsunternehmen und öffentliche Dienste",
      blockchainCryptocurrency: "Blockchain und Kryptowährung",
      specializedRetail: "Spezialisierter Einzelhandel (Nischenprodukte und -dienstleistungen)",
      eventPlanningServices: "Eventplanung und -dienstleistungen",
      transportationEquipment: "Transportmittelherstellung",
      accountingTax: "Buchhaltung und Steuerberatung",
      tourismAdventure: "Tourismus und Abenteuerdienstleistungen",
      shareViaEmailAndSMS: 'Per E-Mail & SMS teilen',
      sendEmail: 'E-Mail senden',  
      sendSMS: 'SMS senden',  
      send: "Senden",  
      sendNow: 'Jetzt senden',  
      schedule: 'Planen',  
      cancel: 'Abbrechen',  
      selectMethod: 'Bitte wählen Sie mindestens eine Methode (E-Mail oder SMS)',
      emailCheck: 'Bitte geben Sie eine E-Mail ein oder deaktivieren Sie die E-Mail-Option.',
      smsCheck: 'Bitte geben Sie eine Telefonnummer ein oder deaktivieren Sie die SMS-Option.',
      searchCustomer: 'Nach Kunde oder Abonnent suchen',  
      emailPlaceholder: 'E-Mail',  
      phonePlaceholder: 'Telefonnummer',  
      sendByEmailAndSMS: 'Per E-Mail & SMS senden',  
      textSend: 'Sie können mehrere E-Mail-Adressen hinzufügen, indem Sie nach jeder ein Komma setzen',  
      sendNotification: 'Sie sind dabei, diese Benachrichtigung an folgende Personen zu senden:',  
      whenToSend: 'Wann möchten Sie sie senden?',  
      bankAccountName: 'Bankkontoname',  
      routeNumber: 'Routing-Nummer',  
      accountNumber: 'Kontonummer',  
      bankAccountAddress: 'Bankadresse',  
      nameAuthorizedPerson: 'Name der berechtigten Person',  
      paymentAmount: 'Zahlungsbetrag',  
      mustBe: 'Muss 9-stellig sein',  
      warning: 'Warnung',  
      messageChangeQuote:  
        'Wenn Sie dieses Präfix erneut ändern, ändert sich die Nummerierung Ihrer Angebote.',  
      messageChangeInvoice:  
        'Wenn Sie dieses Präfix erneut ändern, ändert sich die Nummerierung Ihrer Rechnungen.',  
      messageStartingInvoiceNumber:  
        'Wenn Sie diese Startnummer ändern, wird die Nummerierung Ihrer Rechnungen auf diese Nummer zurückgesetzt.',  
      prefixQuotes: 'Präfix für Angebote (z. B. ANG)',  
      prefixInvoices: 'Präfix für Rechnungen (z. B. RCH)',  
      invoiceStartingNumber: 'Startnummer für Rechnungen',  
      moneyNotEnought: 'Der Betrag muss höher sein als der Gesamtbetrag, um Wechselgeld zu erhalten',  
      controlPanel: 'Bedienfeld',  
      supportPanel: 'Support',  
      menus: 'Menüs',  
      orders: 'Bestellungen',  
      quotes: 'Angebote',  
      invoices: 'Rechnungen',  
      allOrders: 'Alle Bestellungen',  
      customerCredit: 'Kundenkredit',  
      workSheet: 'Arbeitsblatt',  
      cateringOrders: 'Catering-Bestellungen',  
      ordersForDelivery: 'Lieferbestellungen',  
      suscriptors: 'Abonnenten',  
      tickets: 'Bestell-Tickets',  
      categories: 'Kategorien',  
      products: 'Artikel',  
      customers: 'Kunden',  
      tables: 'Tische',  
      taxes: 'Steuern',  
      shippings: 'Lieferpreise',  
      otherCharges: 'Weitere Gebühren',  
      newsletter: 'Newsletter',  
      users: 'Mitarbeiter',  
      suscriptor: 'Abonnenten',  
      createCustomer: "Kunde anlegen",  
      communicationResponse: 'Kommunikationsantworten',  
      smsResponses: "SMS-Antworten",  
      emailResponses: "E-Mail-Antworten",  
      loadingEmailResponses: "E-Mail-Antworten werden geladen...",  
      loadingSmsResponses: "SMS-Antworten werden geladen...",  
      perPage: "Pro Seite",  
      emailNoSent: "E-Mail nicht gesendet",  
      noEmailResponses: "Keine E-Mail-Antworten",  
      noEmailFound: "Keine E-Mail-Antworten für Ihr Konto gefunden",  
      noSmsResponses: "Keine SMS-Antworten",  
      noSmsFound: "Keine SMS-Antworten für Ihr Konto gefunden",  
      createSubscriptor: "Abonnent anlegen",  
      occupation: 'Beruf',  
      roles: 'Rollen',  
      about: 'Über uns Slides',  
      digitalScreens: 'Digitale Anzeigen',  
      editAboutForm: 'Über uns Slide bearbeiten',  
      newAboutForm: 'Neue Über uns Slide erstellen',  
      editDisplayForm: 'Digitale Anzeige bearbeiten',  
      newDisplayForm: 'Digitale Anzeige erstellen',  
      basicConfig: 'Grundkonfiguration',  
      functions: 'Funktionen',  
      colors: 'Farben',  
      variantGroup: 'Auswahlmöglichkeiten',  
      loading: 'Bitte warten...',  
      editColorSetting: 'Farbe bearbeiten',  
      createColorSetting: 'Farbe erstellen',  
      orderCateringForm: 'Catering-Bestellung bearbeiten',  
      deliveryLocation: 'Lieferadresse',  
      cateringMenus: 'Catering-Menüs',  
      payments: 'Zahlungen',  
      ticketDetails: 'Ticket-Details',  
      emptyResult: 'Keine Ergebnisse',  
      cancellationType: 'Stornierungsgrund',  
      changePassword: 'Passwort ändern',  
      restaurantName: 'Geschäftsname',  
      clockinClockout: 'Stempeln',  
      clockin: 'Stempeln (Start)',  
      clockout: 'Stempeln (Ende)',  
      timecard: 'Stempelkarte',  
      timesheet: 'Arbeitszeitnachweis',  
      addContact: 'Kontakt hinzufügen',  
      updateContact: 'Kontakt aktualisieren',  
      contacts: 'Kontakte',  
      staff: 'Personal'  
    },
    placeholder: {
      contactNotFound: 'Kontakt nicht gefunden'
    },
    orderState: {
      started: 'gestartet',
      inKitchen: 'in der Küche',
      cooked: 'zubereitet',
      delivering: 'Lieferung ausstehend',
      delivered: 'geliefert'
    },
    list: {
      buttons: {
        goToControlPanel: 'Zur Verwaltung gehen'
      },
      actions: {
        addANew: 'Neu anlegen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        view: 'Anzeigen'
      },
      entitiesName: {
        menu: 'Menü',
        category: 'Kategorie',
        categoryPlaceholder: 'Kategorie auswählen',
        product: 'Artikel',
        customer: 'Kunde',
        table: 'Tisch',
        tax: 'Steuer',
        taxPlaceholder: 'Steuer auswählen',
        shipping: 'Lieferung',
        otherCharge: 'Zusatzkosten',
        user: 'Mitarbeiter',
        order: 'Bestellung',
        role: 'Rolle',
        about: 'Über uns'
      },
      messages: {
        confirmDelete: 'Löschen bestätigen',
        confirmAccept: 'Artikel bestätigen',
        confirmProduct: 'Möchten Sie diesen Artikel akzeptieren?',
        deleteCategory: 'Möchten Sie diese Kategorie löschen?',
        deleteRestaurant: 'Möchten Sie diesen Betrieb löschen?',
        deleteOrder: 'Möchten Sie diese Bestellung löschen?',
        deleteCredit: 'Möchten Sie diesen Kredit löschen?',
        deleteWorkSheet: 'Möchten Sie dieses Arbeitsblatt löschen?',
        deleteCustomer: 'Möchten Sie diesen Kunden löschen?',
        deleteMenu: 'Möchten Sie dieses Menü löschen?',
        deleteOtherCharge: 'Möchten Sie diese Zusatzkosten löschen?',
        deleteNewsletter: 'Möchten Sie diesen Newsletter löschen?',
        deleteProduct: 'Möchten Sie diesen Artikel löschen?',
        deleteShipping: 'Möchten Sie diese Lieferung löschen?',
        deleteTable: 'Möchten Sie diesen Tisch löschen?',
        deleteTax: 'Möchten Sie diese Steuer löschen?',
        deleteUser: 'Möchten Sie diesen Mitarbeiter löschen?',
        deleteSuscriptor: 'Möchten Sie diesen Abonnenten löschen?',
        deleteRole: 'Möchten Sie diese Rolle löschen?',
        deleteAbout: 'Möchten Sie diese Information löschen?',
        deleteDisplay: 'Möchten Sie diese Anzeige entfernen?',
        deleteOccupation: 'Möchten Sie diesen Beruf löschen?',
        deleteVariantGroup: 'Möchten Sie diese Auswahlmöglichkeiten löschen?',
        infoDeleteSuccess: 'Information',
        invalidCode: 'Ungültiger Code, bitte versuchen Sie es erneut.',
        messageDeleteSuccessCategory: 'Kategorie wurde erfolgreich gelöscht',
        messageDeleteSuccessRestaurant: 'Betrieb wurde erfolgreich gelöscht',
        messageDeleteSuccessOrder: 'Bestellung wurde erfolgreich gelöscht',
        messageDeleteSuccessCredit: 'Kredit wurde erfolgreich gelöscht',
        messageDeleteSuccessWorkSheet: 'Arbeitsblatt wurde erfolgreich gelöscht',
        messageDeleteSuccessCustomer: 'Kunde wurde erfolgreich gelöscht',
        messageDeleteSuccessMenu: 'Menü wurde erfolgreich gelöscht',
        messageDeleteSuccessOtherCharges: 'Zusatzkosten wurden erfolgreich gelöscht',
        messageDeleteSuccessNewsletter: 'Newsletter wurde erfolgreich gelöscht',
        messageDeleteSuccessProduct: 'Artikel wurde erfolgreich gelöscht',
        messageDeleteSuccessShipping: 'Lieferung wurde erfolgreich gelöscht',
        messageDeleteSuccessTable: 'Tisch wurde erfolgreich gelöscht',
        messageDeleteSuccessTax: 'Steuer wurde erfolgreich gelöscht',
        messageDeleteSuccessUser: 'Mitarbeiter wurde erfolgreich gelöscht',
        messageDeleteSuccessSuscriptor: 'Abonnent wurde erfolgreich gelöscht',

        messageActivareSuccessSuscriptor: 'Abonnent wurde erfolgreich aktiviert',
        messageDesactivareSuccessSuscriptor: 'Abonnent wurde erfolgreich deaktiviert',

        messageDeleteSuccessRole: 'Rolle wurde erfolgreich gelöscht',
        messageDeleteSuccessAbout: 'Information wurde erfolgreich gelöscht',
        messageDeleteSuccessOccupation: 'Beruf wurde erfolgreich gelöscht',
        messageDeleteSuccessVariantGroup: 'Auswahlmöglichkeiten wurden erfolgreich gelöscht',
        messageCateringApproved: 'Die Catering-Bestellung wurde erfolgreich genehmigt',
        messageCateringCancelled: 'Die Catering-Bestellung wurde erfolgreich storniert',
        titleEditCategory: 'Kategorie bearbeiten',
        titleEditCustomer: 'Kunde bearbeiten',
        titleEditMenu: 'Menü bearbeiten',
        titleEditOtherCharges: 'Zusatzkosten bearbeiten',
        titleEditProduct: 'Artikel bearbeiten',
        titleEditShipping: 'Lieferung bearbeiten',
        titleEditTable: 'Tisch bearbeiten',
        titleEditTax: 'Steuer bearbeiten',
        titleEditUser: 'Mitarbeiter bearbeiten',
        titleEditRole: 'Rolle bearbeiten',
        titleEditSetting: 'Einstellung bearbeiten',
        titleEditOccupation: 'Beruf bearbeiten',
        titleCreateCategory: 'Kategorie anlegen',
        titleCreateCustomer: 'Kunde anlegen',
        titleCreateMenu: 'Menü anlegen',
        titleCreateOtherCharges: 'Zusatzkosten anlegen',
        titleCreateProduct: 'Artikel anlegen',
        titleCreateShipping: 'Lieferung anlegen',
        titleCreateTable: 'Tisch anlegen',
        titleCreateTax: 'Steuer anlegen',
        titleCreateUser: 'Mitarbeiter anlegen',
        titleCreateRole: 'Rolle anlegen',
        titleCreateSetting: 'Einstellung anlegen',
        titleCreateOccupation: 'Beruf anlegen',
        titleEditVariantGroup: 'Auswahlmöglichkeiten bearbeiten',
        titleCreateVariantGroup: 'Neue Auswahlmöglichkeiten erstellen',
        messageEditSuccessCategory: 'Die Kategorie wurde erfolgreich bearbeitet',
        messageEditSuccessCredit: 'Der Kredit wurde erfolgreich bearbeitet',
        messageEditSuccessCustomer: 'Der Kunde wurde erfolgreich bearbeitet',
        messageEditSuccessMenu: 'Das Menü wurde erfolgreich bearbeitet',
        messageEditSuccessWorksheet: 'Das Arbeitsblatt wurde erfolgreich bearbeitet',
        messageEditSuccessOtherCharges: 'Die Zusatzkosten wurden erfolgreich bearbeitet',
        messageEditSuccessProduct: 'Der Artikel wurde erfolgreich bearbeitet',
        messageEditSuccessShipping: 'Die Lieferung wurde erfolgreich bearbeitet',
        messageEditSuccessTable: 'Der Tisch wurde erfolgreich bearbeitet',
        messageEditSuccessTax: 'Die Steuer wurde erfolgreich bearbeitet',
        messageEditSuccessUser: 'Der Mitarbeiter wurde erfolgreich bearbeitet',

        messageEditSuccessSuscriptor: 'Der Abonnent wurde erfolgreich bearbeitet',
        messageEditSuccesRole: 'Die Rolle wurde erfolgreich bearbeitet',
        messageEditSuccessSetting: 'Die Einstellungen wurden erfolgreich bearbeitet',
        messageEditSuccessOccupation: 'Der Beruf wurde erfolgreich bearbeitet',
        messageEditSuccessVariantGroup: 'Die Auswahlmöglichkeiten wurden erfolgreich bearbeitet',
        messageDeleteSuccessVariant: 'Die Auswahlmöglichkeiten wurden erfolgreich gelöscht',
        messageEditSuccessVariant: 'Die Auswahlmöglichkeiten wurden erfolgreich bearbeitet',
        messageCreateSuccessVariant: 'Die Auswahlmöglichkeiten wurden erfolgreich erstellt',
        messageCreateSuccessCategory: 'Die Kategorie wurde erfolgreich erstellt',
        messageCreateSuccessCredit: 'Der Kredit wurde erfolgreich erstellt',
        messageCreateSuccessCustomer: 'Der Kunde wurde erfolgreich erstellt',
        messageCreateSuccessMenu: 'Das Menü wurde erfolgreich erstellt',
        messageCreateSuccessWorksheet: 'Das Arbeitsblatt wurde erfolgreich erstellt',
        messageCreateSuccessOtherCharges: 'Die Zusatzkosten wurden erfolgreich erstellt',
        messageCreateSuccessProduct: 'Der Artikel wurde erfolgreich erstellt',
        messageCreateSuccessShipping: 'Die Lieferung wurde erfolgreich erstellt',
        messageCreateSuccessTable: 'Der Tisch wurde erfolgreich erstellt',
        messageCreateSuccessTax: 'Die Steuer wurde erfolgreich erstellt',
        messageCreateSuccessUser: 'Der Mitarbeiter wurde erfolgreich erstellt',
        messageCreateSuccessSuscriptor: 'Der Abonnent wurde erfolgreich erstellt',
        messageCreateSuccessRole: 'Die Rolle wurde erfolgreich erstellt',
        messageCreateSuccessSetting: 'Die Einstellung wurde erfolgreich erstellt',
        messageCreateSuccessOccupation: 'Der Beruf wurde erfolgreich erstellt',
        messageCreateSuccessVariantGroup: 'Die Auswahlmöglichkeiten wurden erfolgreich erstellt',
        menuChangeState: 'Menüstatus wurde erfolgreich geändert',
        activeMenu: 'Menü aktivieren',
        otherChargeChangeState: 'Status der Zusatzkosten wurde erfolgreich geändert',
        activeOtherCharge: 'Zusatzkosten aktivieren',
        taxChangeState: 'Steuerstatus wurde erfolgreich geändert',
        activeTax: 'Steuer aktivieren',
        shippingChangeState: 'Lieferstatus wurde erfolgreich geändert',
        activeShipping: 'Lieferung aktivieren',
        deleteSubtitleCategory: 'Kategorie löschen',
        deleteSubtitleCustomer: 'Kunde löschen',
        deleteSubtitleMenu: 'Menü löschen',
        deleteSubtitleOtherCharges: 'Zusatzkosten löschen',
        deleteSubtitleProduct: 'Artikel löschen',
        deleteSubtitleShipping: 'Lieferung löschen',
        deleteSubtitleTable: 'Tisch löschen',
        deleteSubtitleTax: 'Steuer löschen',
        deleteSubtitleUser: 'Mitarbeiter löschen',
        deleteSubtitleRole: 'Rolle löschen',
        deleteSubtitleAbout: 'Information löschen',
        deleteSubtitleOccupation: 'Beruf löschen',
        deleteSubtitleVariantGroup: 'Auswahlmöglichkeiten löschen',
        deleteAertMessage: 'Sind Sie sicher, dass Sie den Kontakt löschen möchten?',
        errorTitle: 'Fehler',
        errorMessage: 'Etwas ist schief gelaufen.',
        changeOrderStateMessage: 'Bestellstatus ändern',
        changeOrderStateSuccess: 'Bestellstatus wurde erfolgreich geändert',
        changeOrderStateCanceled: 'Bestellung wurde storniert',
        connectionError: 'Verbindungsfehler',
        sharedWorksheet: 'Arbeitsblatt mit Mitarbeiter geteilt',
        connectionErrorMessage: 'Es gab einen Verbindungsfehler. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an Ihren Dienstanbieter.',
        newPasswordSent: 'Das neue Passwort wurde an Ihre E-Mail gesendet',
        emailOrPasswordIncorrect: 'E-Mail oder Passwort falsch',
        buttons: {
          cancel: 'Abbrechen',
          delete: 'Löschen',
          close: 'Schließen',
          goToAdministration: 'Zur Verwaltung gehen',
          goToList: 'Zur Liste gehen',
          retry: 'Erneut versuchen'
        }
      }
    },
    form: {
      includeMiddleName: 'Mittlere Name und Nachname',
      login: 'Anmelden',
      events: {
        backgroundImage: 'Hintergrundbild',
        backgroundColor: 'Hintergrundfarbe',
        backgroundColorSection: 'Hintergrundfarbe für diesen Abschnitt hinzufügen',
        backgroundColorDates: 'Hintergrundfarbe für Datumsangaben',
        backgroundColorTitle: 'Hintergrundfarbe für den Titel',
        backgroundColorSubtitle: 'Hintergrundfarbe für den Untertitel',
        backgroundColorDescription: 'Hintergrundfarbe für die Beschreibung',
        backgroundColorFooter: 'Hintergrundfarbe für die Fußzeile',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        startTime: 'Startzeit',
        endTime: 'Endzeit',
        dates: 'Daten',
        title: 'Titel',
        subtitle: 'Untertitel',
        description: 'Beschreibung',
        footer: 'Fußzeile',
        saveToCalendar: 'Zu Google Kalender hinzufügen'
      },
      colour: {
        primaryColor: 'Primärfarbe',
        primary: 'Primär',
        primaryText: 'Primärtext',
        secondaryColor: 'Sekundärfarbe',
        secondary: 'Sekundär',
        secondaryText: 'Sekundärtext',
        tertiaryColor: 'Tertiärfarbe',
        tertiary: 'Tertiär',
        tertiaryText: 'Tertiärtext',
        successColor: 'Erfolgsfarbe',
        success: 'Erfolg',
        successText: 'Erfolgstext',
        dangerColor: 'Gefahrenfarbe',
        danger: 'Gefahr',
        dangerText: 'Gefahrentext',
        backgroundColor: 'Hintergrundfarbe',
        background: 'Hintergrund'
      },
      tableShape: {
        square: 'Quadratisch',
        rectangular: 'Rechteckig',
        circle: 'Rund',
        oval: 'Oval'
      },
      buttons: {
        backToCategoriesList: 'Zurück zur Kategorienliste',
        backToCustomersList: 'Zurück zur Kundenliste',
        backToMenusList: 'Zurück zur Menüliste',
        backToOrdersList: 'Zurück zur Bestellliste',
        backToOtherChargesList: 'Zurück zur Liste der Zusatzkosten',
        backToProductsList: 'Zurück zur Artikelliste',
        backToShippingsList: 'Zurück zur Lieferliste',
        backToTablesList: 'Zurück zur Tischliste',
        backToTaxesList: 'Zurück zur Steuerliste',
        backToUsersList: 'Zurück zur Mitarbeiterliste',
        backToRolesList: 'Zurück zur Rollenliste',
        backToAboutList: 'Zurück zur Über-uns-Liste',
        backToMenu: 'Zurück zum Menü',
        cancelOrder: 'Bestellung stornieren',
        changeState: 'Status ändern zu',
        defaultColor: 'Standardfarbe',
        addChoice: 'Variante hinzufügen',
        back: 'Zurück',
        save: 'Speichern',
        submit: 'Absenden',
        change: 'Ändern',
        add: 'Hinzufügen',
        update: 'Aktualisieren'
      },
      titles: {
        identificationInformation: 'Identifikationsinformationen',
        idType: 'Ausweistyp',
        driverLicense: 'Führerschein',
        internationalId: 'Internationale ID (Cédula)',
        nameLicense: 'Name auf Führerschein',
        licenseNumber: 'Führerscheinnummer',
        issueDate: 'Ausstellungsdatum',
        expirationDate: 'Ablaufdatum',
        sex: 'Geschlecht',
        dateBirth: 'Geburtsdatum',
        meters: "Meter",
        feet: "Fuß",
        centimeters: "Zentimeter",
        inches: "Zoll",
        height: 'Körpergröße',
        nameId: 'Name auf Ausweis',
        identificationNumber: 'Identifikationsnummer',
        nationality: 'Nationalität',
        martialStatus: 'Familienstand',
        single: 'Ledig',
        married: 'Verheiratet',
        divorced: 'Geschieden',
        widowed: 'Verwitwet',
        occupation: 'Beruf',
        socialeMediaChannels: 'Social-Media-Kanäle',
        customerType: 'Kundentyp',
        customerStatus: 'Kundenstatus',
        gender: 'Geschlecht',
        preferredContact: 'Bevorzugte Kontaktmethode',
        enableAll: 'Alle aktivieren',
        disableAll: 'Alle deaktivieren',
        invoiceReminderLabel: 'Geben Sie ein, alle wie viele Tage eine Erinnerung gesendet wird',
        invoiceReminder: 'Rechnungserinnerungen aktivieren',
        assetPickupRequest: 'Abholanfrage für Vermögenswerte',
        pickupAddress: 'Abholadresse',
        requireDeposit: 'Kaution verlangen',
        lateFees: 'Verspätungsgebühren für Rechnungen aktivieren',
        lateFeesLabel: 'Geben Sie den Prozentsatz der rückständigen Beträge ein, der erhoben werden soll',
        thisInvoice: 'Diese Rechnung wurde BEZAHLT',
        customerNewTitle: 'Neuen Kunden anlegen',
        customerEditTitle: 'Kunde bearbeiten',
        categoryNewTitle: 'Neue Kategorie anlegen',
        creditNewTitle: 'Neuen Kredit anlegen',
        categoryEditTitle: 'Kategorie bearbeiten',
        creditEditTitle: 'Kredit bearbeiten',
        menuNewTitle: 'Neues Menü anlegen',
        workSheetNewTitle: 'Arbeitsblatt erstellen',
        menuEditTitle: 'Menü bearbeiten',
        workSheetEditTitle: 'Arbeitsblatt bearbeiten',
        productNewTitle: 'Artikel anlegen',
        serviceNewTitle: 'Dienstleistung anlegen',
        productEditTitle: 'Artikel bearbeiten',
        serviceEditTitle: 'Dienstleistung bearbeiten',
        changePaymentSetting: 'Zahlungseinstellungen ändern',
        shippingNewTitle: 'Neuen Lieferpreis anlegen',
        shippingEditTitle: 'Lieferpreis bearbeiten',
        taxNewTitle: 'Neue Steuer anlegen',
        taxEditTitle: 'Steuer bearbeiten',
        tableNewTitle: 'Neuen Tisch anlegen',
        tableEditTitle: 'Tisch bearbeiten',
        packageNewTitle: 'Neues Paket anlegen',
        packageEditTitleditTitle: 'Paket bearbeiten',
        variantGroupEditTitle: 'Auswahlmöglichkeiten bearbeiten',
        variantGroupNewTitle: 'Neue Auswahlmöglichkeit anlegen',
        otherChargeNewTitle: 'Neue Zusatzkosten anlegen',
        otherChargeEditTitle: 'Zusatzkosten bearbeiten',
        userNewTitle: 'Neuen Mitarbeiter anlegen',

        suscriptionNewTitle: 'Neues Abonnement anlegen',

        driversNewTitle: 'Neuen Fahrer anlegen',
        userEditTitle: 'Mitarbeiter bearbeiten',

        suscriptionEditTitle: 'Abonnement bearbeiten',
        driversEditTitle: 'Fahrer bearbeiten',
        supportUsers: 'Support-Mitarbeiter',
        occupationNewTitle: 'Neuen Beruf/Job anlegen',
        occupationEditTitle: 'Beruf/Job bearbeiten',
        roleNewTitle: 'Berechtigungen hinzufügen',
        roleEditTitle: 'Rolle bearbeiten',
        selectAProduct: 'Artikel auswählen',
        selectACategory: 'Kategorie auswählen',
        selectACustomer: 'Kunde auswählen',
        selectATax: 'Steuer auswählen',
        selectARestaurant: 'Betrieb auswählen',
        selectAState: 'Status auswählen',
        filterCategory: 'Filtern...',
        selectALanguage: 'Sprache',
        selectAnOccupation: 'Beruf auswählen',
        selectACooker: 'Koch auswählen',
        selectADriver: 'Fahrer auswählen',
        allProducts: 'Alle Artikel:',
        settingEditTitle: 'Einstellungen bearbeiten',
        settingNewTitle: 'Einstellungen hinzufügen',
        generalSettingEditTitle: 'Grundeinstellungen bearbeiten',
        generalSettingNewTitle: 'Grundeinstellungen hinzufügen',
        keySettingEditTitle: 'Systemeinstellungen bearbeiten',
        keySettingNewTitle: 'Systemeinstellungen anlegen',
        funSettingEditTitle: 'Funktionseinstellungen',
        funSettingNewTitle: 'Funktionseinstellungen anlegen',
        pickFromSelect: 'Abholung auswählen von',
        pickToSelect: 'Abholung auswählen bis',
        dateFromSelect: 'Datum auswählen von',
        dateToSelect: 'Datum auswählen bis',
        cancelOrder: 'Bestellung stornieren',
        drivers: 'Fahrer',
        customer: 'Kunde',
        date: 'Datum',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        orderType: 'Bestelltyp',
        addressToDelivery: 'Lieferadresse',
        hourToPick: 'Abholzeit',
        tableService: 'Tischservice',
        products: 'Artikel',
        services: 'Dienstleistungen',
        otherCharges: 'Zusatzkosten',
        shippingPrice: 'Lieferpreis',
        subtotal: 'Zwischensumme',
        tax: 'Steuersumme',
        tip: 'Trinkgeld',
        total: 'Gesamtbetrag',
        number: 'Nummer',
        doYou: 'Möchten Sie wirklich löschen',
        marked: 'markierte Datensätze?',
        pendingPay: 'Ausstehende Zahlung',
        payed: 'Bezahlt',
        notes: 'Notizen',
        cancelNotes: 'Stornierungsnotizen',
        pickupNotes: 'Abholnotizen',
        cooker: 'Koch',
        state: 'Status',
        generalConfiguration: 'GRUNDKONFIGURATIONEN',
        paymentConfiguration: 'ZAHLUNGSKONFIGURATIONEN',
        cashDiscount: 'BARGELDRABATT',
        eposConfiguration: 'EPOS-KONFIGURATION',
        emailConfiguration: 'E-MAIL-KONFIGURATIONEN',
        twilioSMS: 'Twilio SMS',
        sinchSMS: 'Sinch SMS',
        selectAVariantGroup: 'Auswahlmöglichkeit auswählen',
        imageText: 'Für optimale Ergebnisse laden Sie bitte Bilder in der Größe 750x750px hoch. Stellen Sie sicher, dass Sie die Rechte für alle hochgeladenen Bilder besitzen',
        orderCateringForm: 'Genehmigung der Catering-Bestellung',
        restaurantHours: 'Betriebszeiten',
        deadlinesNotes: 'Bitte stellen Sie sicher, dass die Summe der Fristen 100 beträgt.',
        selectDate: 'Datum auswählen',
        toPay: 'Zu zahlen',
        pending: 'Ausstehend',
        genaral: 'Allgemein',
        others: 'Sonstiges',
        variants: 'Varianten',
        sides: 'Beilagen',
        ingredients: 'Zutaten',
        shift4: 'Shift4',
        auth: 'Authorize.Net',
        capcha: 'Captcha',
        zipCodes: 'Postleitzahlen',
        backups: 'Backups',
        devices: 'Geräte',
        creditSetting: 'Krediteinstellung'
      },
      fields: {
        createNewCustomer: 'Neuen Kunden anlegen',
        editItem: 'Artikel bearbeiten',
        previewInvoice: 'Rechnungsvorschau',
        companyName: 'Firmenname',
        companyEmail: 'Firmen-E-Mail',
        companyPhone: 'Firmentelefon',
        companyTitle: 'Berufsbezeichnung',
        companyWebSite: 'Firmenwebsite',
        companyIndustry: 'Branche',
        addNewCustomer: 'Neuen Kunden hinzufügen',
        projectName: 'Projektname',
        billingAddress: 'Rechnungsadresse',
        selectCustomerAttachBillingAddress: 'Wählen Sie einen Kunden aus, um eine Rechnungsadresse anzuhängen',
        selectCustomerAttachShippingAddress: 'Wählen Sie einen Kunden aus, um eine Lieferadresse anzuhängen',
        selectedAddress: 'Ausgewählte Adresse:',
        changeAddress: 'Adresse ändern',  
        addAddress: 'Adresse hinzufügen',
        number: 'Nummer',
        shippingAddress: 'Lieferadresse',
        username: 'Benutzername',
        emailLabel: 'E-Mail',
        phoneLabel: 'Telefon',
        firstNameLabel: 'Vorname',
        lastNameLabel: 'Nachname',
        putEmail: 'Geben Sie Ihre E-Mail ein',
        putPhone: 'Geben Sie Ihre Telefonnummer ein',
        putFirstName: 'Geben Sie Ihren Vornamen ein',
        putLastName: 'Geben Sie Ihren Nachnamen ein',
        putUserName: 'Geben Sie Ihren Benutzernamen ein',
        takePicture: 'Foto aufnehmen',
        accept: 'Akzeptieren',
        hidde: 'Verstecken',
        delete: 'Löschen',
        retake: 'Erneut aufnehmen',
        previewPhoto: 'Fotovorschau',
        previewAcceptedPhoto: 'Akzeptierte Fotovorschau',
        viewImenuBookControlPanel: 'iMenuBooks im Kontrollpanel anzeigen',
        viewImenuEngageControlPanel: 'iMenuEngage360 im Kontrollpanel anzeigen',
        viewImenuBookOptions: 'iMenuBooks-Optionen anzeigen',
        viewOrdersOption: 'Bestelloption anzeigen',
        viewReservationOption: 'Reservierungsoption anzeigen',
        viewInvoiceOption: 'Rechnungsoption anzeigen',
        viewQuoteOption: 'Angebotsoption anzeigen',
        changeImage: 'Bild ändern',
        addImage: 'Bild hinzufügen',
        customerHours: 'Kundenstunden',
        to: 'Bis',
        subject: 'Betreff',
        message: 'Nachricht',
        name: 'Name',
        menuName: 'Menüname',
        description: 'Beschreibung',
        email: 'E-Mail',
        password: 'Passwort',
        date: 'Datum',
        image: 'Bild',
        phone: 'Telefon',
        productMin: 'Mindestanzahl Artikel',
        productMax: 'Höchstanzahl Artikel',
        price: 'Preis',
        extraCharge: 'Zusatzkosten',
        costPrice: 'Kosten',
        retailPrice: 'Verkauf',
        stimateTime: 'Voraussichtliche Zeit (in Minuten)',
        stockQuantity: 'Lagerbestand',
        minReorderPoint: 'Mindestbestand',
        maxReorderPoint: 'Maximalbestand',
        CreditAmount: 'Kreditbetrag',
        vendorName: 'Lieferantname',
        vendorCode: 'Lieferantencode',
        shortDescription: 'Kurzbeschreibung',
        keywords: 'Schlüsselwörter',
        tags: 'Tags',
        binNumber: 'Behälternummer',
        addSerialNumber: 'Seriennummer hinzufügen',
        active: 'Aktivieren',
        save: 'Speichern',
        submitToken: 'Token übermitteln',
        available: 'Verfügbar',
        availableCategories: 'VERFÜGBARE KATEGORIEN',
        availableProducts: 'VERFÜGBARE ARTIKEL',
        availableStaff: 'VERFÜGBARE MITARBEITER',
        selectedProducts: 'AUSGEWÄHLTE ARTIKEL',
        selectedCategories: 'AUSGEWÄHLTE KATEGORIEN',
        selectedStaff: 'AUSGEWÄHLTE MITARBEITER',
        workedHours: 'GEARBEITETE STUNDEN',
        scheduledDates: 'Geplante Termine',
        selectedAggregates: 'AUSGEWÄHLTE AGGREGATE',
        marketingConsent: 'MARKETING-EINWILLIGUNG',
        product: 'Artikel',
        category: 'Kategorie',
        tax: 'Steuer',
        parentCategory: 'Übergeordnete Kategorie',
        qrCode: 'QR-Code',
        capacity: 'Kapazität',
        percent: 'Prozentsatz',
        priority: 'Priorität (0 - 1)',
        permissions: 'Berechtigungen',
        permissionsRole: 'Berechtigungsrollen',
        selectCashDiscount: 'Bargeldrabatt auswählen',
        roles: 'Beruf/Job',
        address: 'Adresse',
        title: 'Titel',
        subtitle: 'Untertitel',
        online: 'Online',
        showOtherRestaurant: 'Andere Betriebe anzeigen',
        reservationByTable: 'Tisch reservieren',
        reservationByStaff: 'Mitarbeiter buchen',
        tablesChoose: 'Kunde kann Tischstandort wählen',
        onlineMss: 'Betrieb ist nicht öffentlich sichtbar',
        onlineMss1: 'Betrieb ist öffentlich sichtbar',
        mustClockinMss: 'Sie müssen sich zuerst einstempeln. Bitte',
        mustClockin2Mss: 'stempeln Sie ein.',
        SelectPickHour: 'Abholzeit auswählen',
        SelectPickHour2: 'Abholzeit aktivieren',
        TipRequire: 'Trinkgeld verlangen',
        tips: 'Trinkgelder',
        assetPickup: 'Abholung von Vermögenswerten',
        depositAmount: 'Höhe der Kaution',
        typeTip: 'Trinkgeldprozentsatz eingeben',
        MinTimeToCook: 'Mindestzubereitungszeit',
        PickFrom: 'Abholung beginnt um',
        PickFromToolTip: 'Geben Sie die Zeit an, zu der die Lieferung beginnt',
        PickTo: 'Ende der Abholzeit',
        PickToToolTip: 'Geben Sie die Zeit an, zu der die Lieferung endet',
        DateFrom: 'Datum von',
        DateTo: 'Datum bis',
        DateLimit: 'Zahlungsfrist',
        ShowCooker: 'Koch anzeigen',
        zipCodes: 'Postleitzahlen',
        deliveryZone: 'Lieferzonen',
        cooker: 'Koch',
        driver: 'Fahrer',
        rejectedOrder: 'Bestellung vom Fahrer abgelehnt',
        cancelationNote: 'Stornierungsnotiz',
        tableNumber: 'Tischnummer',
        firstName: 'Vorname',
        lastName: 'Nachname',
        occupation: 'Beruf',
        confirmPassword: 'Passwort bestätigen',
        endPointUrl: 'Endpunkt-URL',
        capchaKey: 'Captcha-Schlüssel',
        clientGuid: 'Client-GUID',
        interfazVersion: 'Schnittstellenversion',
        interfazName: 'Schnittstellenname',
        apiLoginId: 'API-Login-ID',
        eposToken: 'ePos-Token',
        epos: 'Mit ePos integrieren',
        transactionKey: 'Transaktionsschlüssel',
        smtpHost: 'SMTP-Host',
        port: 'Port',
        secure: 'Sicher',
        twFromNumber: 'Absendernummer',
        twAccountSID: 'Account-SID',
        twToken: 'Token',
        sinchFromNumber: 'Absendernummer',
        sinchAccountSID: 'Serviceplan-ID',
        sinchToken: 'Token',
        web: 'Webseite',
        variantGroup: 'Auswahlmöglichkeiten',
        haveSides: 'Beilagen',
        cantOfSides: 'Anzahl der enthaltenen Beilagen',
        categoryOfSides: 'Beilagen nach Kategorie filtern',
        addIngredients: 'Zutaten angeben',
        typeAnIngredient: 'Zutat eingeben',
        canViewGeoposition: 'Geoposition anzeigen können',
        canViewRating: 'Bewertung anzeigen können',
        viewDelivery: 'Lieferbestellungen erstellen können',
        viewOnTable: 'Tischbestellungen erstellen können',
        viewCurbside: 'Curbside-Bestellungen erstellen können',
        tablePrefix: 'Tischpräfix',
        barPrefix: 'Barpräfix',
        roomPrefix: 'Zimmerpräfix',
        typeZipCode: 'Postleitzahl eingeben',
        isCatering: 'Ist Catering',
        isService: 'Dienstleistungsmenü',
        isReservationMenu: 'Reservierungsmenü',
        catering: 'Catering',
        minAmoutCatering: 'Mindestbetrag für Catering',
        minAmountCateringDelivery: 'Mindestbetrag für Lieferung',
        loyaltyMinPointToBuy: 'Mindestpunkte zum Kauf',
        loyaltyExpirationMonths: 'Ablauf der Treuepunkte in Monaten',
        loyaltyPointMoney: 'Anzahl der Punkte für 1 $',
        partialPay: 'Teilzahlung',
        payForQuotation: 'Vorauszahlung für Angebot',
        percentPayForQuotation: 'Vorauszahlungsbetrag für Angebot',
        service: 'Dienstleistung',
        showServicePrice: 'Dienstleistungspreis anzeigen',
        viewCatering: 'Catering anzeigen',
        viewLoyalty: 'Treueprogramm anzeigen',
        viewReservation: 'Reservierung anzeigen',
        reservation: 'Reservierung',
        loyalty: 'Treueprogramm',
        minDayToReservation: 'Mindestanzahl der Tage für Reservierung',
        viewCustomerReservation: 'Kundenreservierungen anzeigen',
        sameHourForAllDays: 'Gleiche Uhrzeit für alle Tage',
        followingDays: 'Gleiche Stunden für die folgenden Tage',
        timezone: 'Zeitzone',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
        allDays: 'Alle Tage',
        marginDays: 'Mindestanzahl der Tage für Bestellung',
        cateringStates: 'Catering-Status',
        typeState: 'Statuscode eingeben',
        zipCodesExclude: 'Eingeschlossene Postleitzahlen',
        cateringEvents: 'Catering-Veranstaltung',
        typeEventName: 'Veranstaltungsname eingeben',
        proposeNewDataTime: 'Neues Datum/Uhrzeit vorschlagen',
        fixed: 'Fester Betrag',
        amount: 'Betrag',
        discount: 'Rabatt',
        deadlines: 'Fristen',
        pendingPay: 'Ausstehende Zahlung',
        payed: 'Bezahlt',
        states: 'Status',
        paymentMethod: 'Zahlungsmethode',
        cash: 'Bar',
        card: 'Karte',
        check: 'Scheck',
        free: 'Frei',
        busy: 'Besetzt',
        dirty: 'Schmutzig',
        authenticationToken: 'Autorisierungstoken',
        authenticationTokenMoto: 'MOTO-Autorisierungstoken',
        authenticationTokenFB: 'F&B-Autorisierungstoken',
        accountType: 'Kontotyp',
        method: 'Methode',
        serverName: 'Servername',
        urlLocation: 'URL-Standort',
        fax: 'Fax',
        oldServerId: 'Alte Mitarbeiter-ID',
        newServerId: 'Neue Mitarbeiter-ID',
        acivateTwilio: 'Twilio aktivieren',
        acivateSinch: 'Sinch aktivieren',
        isDriver: 'Ist Fahrer',
        monthy: 'Monatlich',
        anual: 'Jährlich',
        merchantOnboardingApplication: 'Händler-Onboarding-Anwendung',
        applicationName: 'Anwendungsname',
        agentId: 'Agenten-ID',
        planId: 'Plan-ID',
        dateOfBirth: 'Geburtsdatum',
        equityOwnershipPercent: 'Eigenkapitalanteil in Prozent',
        isPersonalGuarantor: 'Ist persönlicher Bürge?',
        bookablePackage: 'Ist buchbares Paket',
        showProgressBar: 'Fortschrittsbalken für Fahrer anzeigen'
      },
      messages: {
        buttons: {
          ok: 'OK',
          dismiss: 'Verwerfen'
        },
        activatePaymentMethod: 'wurde aktiviert.',
        incorrectToken: 'Der gesendete Token ist nicht korrekt.',
        activationMethodError: 'Die Aktivierungsmethode hat einen Fehler zurückgegeben.',
        unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten.',
        savePaymentMethodSuccess: 'Die Zahlungsmethodeneinstellungen wurden gespeichert.',
        savePaymentMethodError:
      'Fehler beim Speichern der Zahlungsmethoden-Einstellungen.'  
      },
      validate: {
        emailExisteTitle: 'E-Mail existiert bereits',
        emailExistMessage: 'Diese E-Mail ist bereits registriert. Bitte verwenden Sie eine andere E-Mail-Adresse oder bitten Sie den Benutzer, auf "Passwort vergessen" im Anmeldebildschirm zu klicken.',
        validate: 'Validieren',
        validateCategory: 'Kategorie validieren',
        validateCustomer: 'Kunde validieren',
        validateMenu: 'Menü validieren',
        validateOtherCharge: 'Zusatzkosten validieren',
        validateProduct: 'Artikel validieren',
        validateShipping: 'Lieferung validieren',
        validateTable: 'Tisch validieren',
        validateTax: 'Steuer validieren',
        validateUser: 'Benutzer validieren',
        validateRole: 'Rolle validieren',
        validateSetting: 'Einstellung validieren',
        validateOccupation: 'Tätigkeit validieren',
        validateVariantGroup: 'Auswahlmöglichkeiten validieren',
        name: 'Name ist erforderlich',
        image: 'Bild ist erforderlich',
        email: 'E-Mail ist erforderlich',
        phone: 'Telefon ist erforderlich',
        emailIncorrect: 'E-Mail ist ungültig',
        date: 'Datum ist erforderlich',
        selectedCategories: 'Mindestens eine Kategorie muss ausgewählt sein',
        productMinNumber: 'Artikel-Minimum muss eine Zahl sein',
        productMaxNumber: 'Artikel-Maximum muss eine Zahl sein',
        productMinGreater: 'Artikel-Minimum muss größer als 0 sein',
        productMaxGreater: 'Artikel-Maximum muss größer als 2 sein',
        price: 'Preis muss eine Zahl sein',
        priceGreater: 'Preis muss größer als 0 sein',
        product: 'Sie müssen einen Artikel auswählen',
        costPriceNumber: 'Einkaufspreis muss eine Zahl sein',
        retailPriceNumber: 'Verkaufspreis muss eine Zahl sein',
        retailPriceShouldBeGreaterThanSalePrice: 'Der Verkaufspreis muss immer höher als der Angebotspreis sein',
        costPriceGreater: 'Einkaufspreis muss größer als 0 sein',
        retailPriceGreater: 'Verkaufspreis muss größer als 0 sein',
        category: 'Sie müssen eine Kategorie auswählen',
        capacity: 'Kapazität muss eine Zahl sein',
        capacityGreater: 'Kapazität muss größer als 0 sein',
        percent: 'Prozentsatz muss eine Zahl sein',
        percentGreater: 'Prozentsatz muss größer als 0 sein',
        password: 'Passwort ist erforderlich',
        address: 'Adresse ist erforderlich',
        title: 'Titel ist erforderlich',
        subtitle: 'Untertitel ist erforderlich',
        zipCode: 'Die Postleitzahl ist ungültig',
        duplicateZipCode: 'Doppelte Postleitzahl',
        cateringPriceZero: 'Der Catering-Preis ist Null',
        cooker: 'Das Kochfeld muss ausgefüllt werden',
        tableNumber: 'Tischnummer muss eine Zahl sein',
        tableNumberGreater: 'Tischnummer muss größer als 0 sein',
        nameDuplicate: 'Es existiert bereits ein Tisch mit diesem Namen. Bitte ändern Sie die Nummer oder den Typ.',
        firstName: 'Vorname muss ausgefüllt werden',
        lastName: 'Nachname muss ausgefüllt werden',
        confirmPassword: 'Passwort und Bestätigungspasswort müssen übereinstimmen',
        occupation: 'Das Tätigkeitsfeld muss ausgefüllt werden',
        notes: 'Stornierungsnotiz muss ausgefüllt werden',
        tip: 'Trinkgeld darf nicht Null sein',
        tipRepeat: 'Trinkgeld existiert bereits. Bitte geben Sie einen neuen Betrag ein.',
        emailDontExist: 'E-Mail existiert nicht.',
        ingredient: 'Zutat existiert bereits.'
      },
      permissionsGroup: {
        permissionMenu: 'MENÜ-BERECHTIGUNGEN',
        permissionCategory: 'KATEGORIE-BERECHTIGUNGEN',
        permissionProduct: 'ARTIKEL-BERECHTIGUNGEN',
        permissionSpecialPrice: 'SONDERPREIS-BERECHTIGUNGEN',
        permissionCustomer: 'KUNDEN-BERECHTIGUNGEN',
        permissionCredit: 'KREDIT-BERECHTIGUNGEN',
        permissionHouseAccount: 'HAUSKONTO-BERECHTIGUNGEN',
        permissionTable: 'TISCH-BERECHTIGUNGEN',
        permissionTax: 'STEUER-BERECHTIGUNGEN',
        permissionShipping: 'LIEFERUNG-BERECHTIGUNGEN',
        permissionOtherCharge: 'ZUSATZKOSTEN-BERECHTIGUNGEN',
        permissionUser: 'MITARBEITER-BERECHTIGUNGEN',
        permissionDriver: 'FAHRERAUFSICHTS-BERECHTIGUNGEN',
        permissionDeliveryDriver: 'LIEFERFAHRER-BERECHTIGUNGEN',
        permissionOrder: 'BESTELLUNG-BERECHTIGUNGEN',
        permissionRole: 'ROLLEN-BERECHTIGUNGEN',
        permissionWorkSheet: 'ARBEITSBLATT-BERECHTIGUNGEN',
        permissionSetting: 'EINSTELLUNGEN-BERECHTIGUNGEN',
        permissionPayment: 'ZAHLUNG-BERECHTIGUNGEN',
        permissionReport: 'BERICHTE-BERECHTIGUNGEN',
        permissionClockin: 'ZEITERFASSUNG-BERECHTIGUNGEN',
        permissionOccupation: 'TÄTIGKEITS-BERECHTIGUNGEN',
        permissionVariantGroup: 'AUSWAHL-BERECHTIGUNGEN',
        permissionReservation: 'RESERVIERUNG-BERECHTIGUNGEN',
        permissionSuscriptors: 'ABONNENTEN-BERECHTIGUNGEN',
        permissionSuscription: 'ABONNEMENT-BERECHTIGUNGEN',
        canViewMenu: 'Kann Menüs anzeigen',
        canCreateMenu: 'Kann Menüs erstellen',
        canEditMenu: 'Kann Menüs bearbeiten',
        canDeleteMenu: 'Kann Menüs löschen',
        canViewCategory: 'Kann Kategorien anzeigen',
        canCreateCategory: 'Kann Kategorien erstellen',
        canEditCategory: 'Kann Kategorien bearbeiten',
        canDeleteCategory: 'Kann Kategorien löschen',
        canViewProduct: 'Kann Artikel anzeigen',
        canCreateProduct: 'Kann Artikel erstellen',
        canEditProduct: 'Kann Artikel bearbeiten',
        canDeleteProduct: 'Kann Artikel löschen',
        canViewSpecialPrices: 'Kann Sonderpreise anzeigen',
        canCreateSpecialPrices: 'Kann Sonderpreise erstellen',
        canEditSpecialPrices: 'Kann Sonderpreise bearbeiten',
        canDeleteSpecialPrices: 'Kann Sonderpreise löschen',
        canViewCustomer: 'Kann Kunden anzeigen',
        canCreateCustomer: 'Kann Kunden erstellen',
        canEditCustomer: 'Kann Kunden bearbeiten',
        canDeleteCustomer: 'Kann Kunden löschen',
        canViewCredit: 'Kann Kredite anzeigen',
        canCreateCredit: 'Kann Kredite erstellen',
        canEditCredit: 'Kann Kredite bearbeiten',
        canDeleteCredit: 'Kann Kredite löschen',
        canViewHouseAccount: 'Kann Hauskonten anzeigen',
        canCreateHouseAccount: 'Kann Hauskonten erstellen',
        canCreateSuscriptor: 'Kann Abonnenten erstellen',
        canViewSuscriptor: 'Kann Abonnenten anzeigen',
        canEditSuscriptor: 'Kann Abonnenten bearbeiten',
        canDesactivateSuscriptor: 'Kann Abonnenten deaktivieren',
        canViewTable: 'Kann Tische anzeigen',
        canCreateTable: 'Kann Tische erstellen',
        canEditTable: 'Kann Tische bearbeiten',
        canDeleteTable: 'Kann Tische löschen',
        canViewTax: 'Kann Steuern anzeigen',
        canCreateTax: 'Kann Steuern erstellen',
        canEditTax: 'Kann Steuern bearbeiten',
        canDeleteTax: 'Kann Steuern löschen',
        canViewShipping: 'Kann Lieferungen anzeigen',
        canCreateShipping: 'Kann Lieferungen erstellen',
        canEditShipping: 'Kann Lieferungen bearbeiten',
        canDeleteShipping: 'Kann Lieferungen löschen',
        canViewOtherCharge: 'Kann Zusatzkosten anzeigen',
        canCreateOtherCharge: 'Kann Zusatzkosten erstellen',
        canEditOtherCharge: 'Kann Zusatzkosten bearbeiten',
        canDeleteOtherCharge: 'Kann Zusatzkosten löschen',
        canViewUser: 'Kann Benutzer anzeigen',
        canCreateUser: 'Kann Benutzer erstellen',
        canEditUser: 'Kann Benutzer bearbeiten',
        canDeleteUser: 'Kann Benutzer löschen',
        canViewDriver: 'Kann externe Fahrer anzeigen',
        canCreateDriver: 'Kann externe Fahrer erstellen',
        canEditDriver: 'Kann externe Fahrer bearbeiten',
        canDeleteDriver: 'Kann externe Fahrer löschen',
        canViewDeliveryDriver: 'Kann Lieferfahrer anzeigen',
        canEditDeliveryStatus: 'Kann Lieferstatus bearbeiten',
        canCreateDeliveryDriver: 'Kann Lieferfahrer erstellen',
        canDeleteDeliveryDriver: 'Kann Lieferfahrer löschen',
        canViewOccupation: 'Kann Tätigkeiten anzeigen',
        canCreateOccupation: 'Kann Tätigkeiten erstellen',
        canEditOccupation: 'Kann Tätigkeiten bearbeiten',
        canDeleteOccupation: 'Kann Tätigkeiten löschen',
        canViewRole: 'Kann Rollen anzeigen',
        canCreateRole: 'Kann Rollen erstellen',
        canEditRole: 'Kann Rollen bearbeiten',
        canDeleteRole: 'Kann Rollen löschen',
        canViewWorkSheet: 'Kann Arbeitsblätter anzeigen',
        canCreateWorkSheet: 'Kann Arbeitsblätter erstellen',
        canEditWorkSheet: 'Kann Arbeitsblätter bearbeiten',
        canDeleteWorkSheet: 'Kann Arbeitsblätter löschen',
        canViewOrder: 'Kann Bestellungen anzeigen',
        canEditOrder: 'Kann Bestellungen bearbeiten',
        canCreateOrder: 'Kann Bestellungen erstellen',
        canViewOrderForDelivery: 'Kann Lieferbestellungen anzeigen',
        canChangeSetting: 'Kann Einstellungen ändern',
        canViewVariantGroup: 'Kann Auswahlmöglichkeiten anzeigen',
        canCreateVariantGroup: 'Kann Auswahlmöglichkeiten erstellen',
        canEditVariantGroup: 'Kann Auswahlmöglichkeiten bearbeiten',
        canDeleteVariantGroup: 'Kann Auswahlmöglichkeiten löschen',
        canViewReservation: 'Kann Reservierungen anzeigen',
        canCreateReservation: 'Kann Reservierungen erstellen',
        canEditReservation: 'Kann Reservierungen bearbeiten',
        canDeleteReservation: 'Kann Reservierungen löschen',
        canViewPayment: 'Kann Zahlungen anzeigen',
        canIgnoreClockin: 'Kann Zeiterfassung ignorieren',
        canViewSalesByCustomer: 'Kann Verkäufe nach Kunde anzeigen',
        canViewSalesByProduct: 'Kann Verkäufe nach Artikel anzeigen',
        canViewDynamicReports: 'Kann dynamische Berichte anzeigen',
        canViewSubscription: 'Kann Abonnements anzeigen',
        canCreateSubscription: 'Kann Abonnements erstellen',
        canEditSubscription: 'Kann Abonnements bearbeiten',
        canDeleteSubscription: 'Kann Abonnements löschen'
      },
      marketingMessages: {
        orderInfo: 'Bestellinformationen',
        inKitchen: ', Hallo! Vielen Dank für Ihre Bestellung. Ihre Bestellung wird gerade in unserer Küche zubereitet.',
        cooked: 'Ihre Bestellung ist fertig. Sie sieht großartig aus!',
        delivering: 'Ihre Bestellung ist bereits unterwegs. Nur noch wenige Minuten, bitte.',
        delivered: 'Ihre Bestellung wurde geliefert. Guten Appetit!',
        canceled: 'Ihre Bestellung wurde storniert.',
        cateringApproved: ', Ihr Catering-Auftrag wurde genehmigt. Bitte überprüfen Sie Ihre E-Mail für Bestelldetails.',
        cateringCancel: ', leider wurde Ihr Catering-Auftrag storniert.',
        reservationChangeStatus: 'Reservierungsstatus geändert',
        reservationApproved: ', Hallo! Ihre Reservierung wurde bestätigt für ',
        reservationApproved2: ', Sie müssen die Reservierung jetzt bestätigen.',
        reservationProposedDateTime: ', Hallo! Leider können wir Ihren gewünschten Termin/Zeit nicht einhalten. Wir schlagen einen neuen Termin vor: ',
        reservationRejected: ', Hallo! Leider müssen wir Ihre Reservierung aufgrund von Kapazitätsmangel ablehnen.',
        reservationCancel: 'Ihre Reservierung wurde storniert. Bei Fragen können Sie uns gerne kontaktieren.'
      }
    },
  },
  frontend: {
    menu: {
      clockInMessage: 'Sie haben sich erfolgreich eingestempelt',
      signIn: 'Anmelden',
      chatImenu: 'iMenuApps® Support',
      trackYourPackage: 'Sendungsverfolgung',
      aboutImenu: 'Über iMenuApps®',
      seeLess: 'Weniger anzeigen',
      seeMore: 'Mehr anzeigen',
      foodAndMoodJournal: 'Essen und Stimmung Tagebuch',
      motivation: `Um Ihre Bestellhistorie einzusehen, laden Sie die iMenuApps®-App herunter und registrieren Sie sich.
          <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">Im Apple App Store herunterladen</a> oder 
          <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">Bei Google Play herunterladen</a>.`,
      motivationMobile: 'Um Ihre Bestellhistorie einzusehen, registrieren Sie sich bei iMenuApps®.',
      menu: 'Menü',
      shop: 'Shop',
      ads: 'Digitale Beschilderung',
      credit: 'Guthaben',
      menuCatering: 'Catering-Menü',
      pickupRequest: 'Abholanfrage',
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzrichtlinie',
      otherPolicy: 'Weitere Richtlinien',
      reservation: 'Reservierungen',
      about: 'Über uns',
      chat: 'Chat',
      eMarkeeting: 'E-Marketing',
      contact: 'Kontakt',
      oferts: 'Angebot',
      init: 'Startseite',
      loginMerchant: 'Händler-Login',
      loginClient: 'Kunden-Login',
      editProfile: 'Profil bearbeiten',
      edit: 'Daten bearbeiten',
      log: 'Anmelden / Registrieren',
      membersLogin: 'Mitglieder-Login',
      membersRegister: 'Mitglieder-Registrierung',
      merchantsLogin: 'Händler-Login',
      catering: 'Catering-Service',
      logout: 'Abmelden',
      logIn: 'Login',
      profil: 'Mein Konto',
      profil1: 'Profil',
      createUser: 'Registrieren',
      forgotPassword: 'Passwort vergessen?',
      passwordReset: 'Passwort zurücksetzen',
      newPassword: 'Neues Passwort',
      newData: 'Daten ändern',
      confirmPassword: 'Passwort bestätigen',
      register: 'Registrieren',
      orders: 'Bestellungen',
      restaurant: 'Klicken Sie unten, um die Geschäftsart auszuwählen',
      restablacerPassword: 'Passwort zurücksetzen',
      updateData: 'Daten aktualisieren',
      mssForgotPassword: 'Wir haben ein neues Passwort an Ihre E-Mail gesendet.',
      errorLogIn: 'Falsche E-Mail oder falsches Passwort',
      errEmailExist: 'Diese E-Mail existiert bereits',
      errPassNotCoinc: 'Stimmt nicht mit dem neuen Passwort überein',
      userNotFound: 'Falsche E-Mail',
      refresh: 'Aktualisieren',
      mssUpdateData: 'Ihre Daten wurden erfolgreich aktualisiert',
      mssCreateUser: 'Kunde erfolgreich erstellt. Wir haben Ihr neues Passwort per E-Mail gesendet.',
      mssPasswordChangedCorrectly: 'Passwort erfolgreich aktualisiert',
      ticketMenu: 'Ticket öffnen'
    },
    app: {
      convertToProd: 'Testversion in Produktion umwandeln',
      convert: 'Umwandeln',
      daysOfTrial: 'Testtage',
      trialExpired: 'Testversion abgelaufen',
      trialMessageExpired: 'Ihre kostenlose Testversion von iMenuApps® ist abgelaufen. Um weiterhin alle Funktionen nutzen zu können, kaufen Sie jetzt eine Lizenz. Bitte senden Sie uns eine E-Mail mit Ihrem Geschäftsnamen an support@imenuapps.com',
      allBusiness: 'Alle Unternehmen',
      hospitality: 'Gastgewerbe',
      reservations: 'Reservierungen',
      service: 'Dienstleistung',
      entertainment: 'Unterhaltung',
      retail: 'Einzelhandel',
      fullText: 'iMenuApps® stellt eine umfassende Geschäftslösung mit erweitertem Kundenportal vor. Unsere Plattform revolutioniert die Art und Weise, wie Sie Ihr Unternehmen führen und mit Kunden interagieren. Mit unserem Kundenportal können Kunden problemlos Produkte und Dienstleistungen nachbestellen und alle Transaktionen und Profile bei jedem Händler auf unserer Plattform verwalten. Egal ob Gastgewerbe, Einzelhandel, Dienstleistung oder Unterhaltung – iMenuApps® ist die ultimative Lösung für Ihre branchenspezifischen Anforderungen.',
      thisPay: 'Diese Zahlung wurde getätigt',
      thisPayDone: 'Diese Zahlung wurde bereits getätigt.',
      selectOrder: 'Bestellart auswählen',
      selectDetail: 'Ihre Dateninformationen',
      deliver: 'Lieferung',
      pickup: 'Abholung',
      table: 'Tisch',
      curbside: 'Bordsteinabholung',
      notClient: 'Es sind keine Bestellungen mit diesem Kunden verknüpft. Nur registrierte Kunden können ihre Bestellungen einsehen.',
      getOrder: 'Bestellungen abrufen',
      editTitle: 'Daten bearbeiten',
      notPermissionForRating: 'Nur registrierte Benutzer können ein Unternehmen bewerten',
      thanksForRating: 'Danke für Ihre Bewertung',
      sessionExpired: 'Ihre Sitzung ist aufgrund von Inaktivität abgelaufen. Bitte melden Sie sich erneut an.',
      notRestaurantFound: 'Das angeforderte Unternehmen existiert nicht. Wir hoffen, Sie finden ein anderes in unserer Liste.',
      all: 'Alle',
      productsAndServices: 'Verkäufe',
      reservation: 'Buchungen'
    },
    product: {
      title: 'Artikel von',
      back: 'Zurück',
      noProducts: 'Entschuldigung! Diese Kategorie hat noch keine Artikel.',
      productDetail: 'Artikeldetails',
      massageToast: 'Erfolgreich',
      productNote: 'Geben Sie hier Ihre Artikelnotiz ein...',
      productWithVariant: 'Klicken Sie auf HINZUFÜGEN für weitere Auswahlmöglichkeiten'
    },
    home: {
      country: 'Land',
      stateProvince: 'Bundesland/Provinz/Region',
      county: 'Landkreis',
      autocomplete: 'Beginnen Sie hier mit der Eingabe Ihrer Adresse für die automatische Vervollständigung',
      selectCategory: 'Menükategorien',
      cardTitle: 'Warenkorbbdetails',
      cardheader: 'Artikel',
      cancel: 'Abbrechen',
      acept: 'OK',
      confirm: 'Bestätigen',
      clear: 'Leeren',
      checkout: 'Zur Kasse',
      deliverDetail: 'Lieferdetails',
      address: 'Adresse',
      pickupDetail: 'Abholdetails',
      curbsideDetail: 'Details zur Bordsteinabholung',
      cateringDate: 'Catering-Datum',
      pickTime: 'Abholzeit nicht verfügbar. Bitte wählen Sie eine andere Abholzeit',
      tableQr: 'Standort-QR',
      notValidQr: 'Kein gültiger QR-Code',
      notSeatAvailable: 'Dieser Sitz ist bereits vergeben',
      errorRequired: 'Erforderliche Informationen eingeben',
      errorDateNotValid: 'Ungültiges Datum',
      noProductForReorder: 'Keine Artikel für eine Nachbestellung verfügbar.',
      noProductAvailable: 'Folgende Artikel sind heute nicht verfügbar und erscheinen nicht in der Bestellung.',
      clientRequired: 'Diese Aktion ist nur für registrierte Benutzer möglich. Bitte anmelden.',
      cantNotValid: 'Die Artikelmenge ist ungültig',
      zipCodeNotValid: 'Ungültige Postleitzahl.',
      notZoneToDeliver: 'Wir liefern derzeit nicht in diesem Gebiet.',
      state: 'Bundesland',
      city: 'Stadt',
      notValidEmail: 'Ungültige E-Mail',
      reqSuccess: 'Änderungsanfrage erfolgreich übermittelt!',
      approveSuccess: 'Änderungsanfrage erfolgreich genehmigt!',
      alertDeleteData: 'Möchten Sie von vorne beginnen?',
      notTimeToPick: 'Abholzeiten sind zwischen: ',
      cookTime: '. Die voraussichtliche Zubereitungszeit beträgt ',
      priceEstimated: 'Voraussichtlicher Preis',
      minuts: ' Minuten.',
      selectOrderType: 'Bitte wählen Sie Ihre Bestellart aus.',
      search: 'Suche',
      aggregateFree: 'Kostenlos enthalten',
      sides: 'Beilagen',
      choises: 'Zutaten',
      variants: 'Varianten',
      withoutIngredients: 'Ohne Zutaten',
      eventType: 'Veranstaltungsart',
      emailSended: 'E-Mail gesendet',
      choseView: 'Optionale Ansichten',
      applicationCreateSuccess: 'Anwendung erfolgreich erstellt',
      applicationCreateError: 'Fehler beim Erstellen der Anwendung'
    },
    genderOptions: {
      male: 'Männlich',
      female: 'Weiblich',
      nonBinary: 'Nicht-binär',
      transgenderMale: 'Transgender Mann',
      transgenderFemale: 'Transgender Frau',
      genderqueer: 'Genderqueer',
      genderfluid: 'Genderfluid',
      agender: 'Agender',
      twoSpirit: 'Two-Spirit',
      bigender: 'Bigender',
      demiboy: 'Demiboy',
      demigirl: 'Demigirl',
      androgynous: 'Androgyn',
      intersex: 'Intersex',
      neutrois: 'Neutrois',
      pangender: 'Pangender',
      polygender: 'Polygender',
      preferNotToSay: 'Keine Angabe',
      other: 'Andere'
    },
    orderType: {
      customerType: 'Kundentyp',
      lastContacted: 'Zuletzt kontaktiert',
      nextFollowUp: 'Nächste Nachverfolgung',
      preferredContactTime: 'Bevorzugte Kontaktzeit',
      preferredContactToTime: 'Bevorzugte Kontaktzeit bis',
      order: 'Bestellung',
      invoice: 'Rechnung',
      quote: 'Angebot',
      email: 'E-Mail',
      password: 'Passwort',
      emailPhone: 'E-Mail und Telefon',
      name: 'Vorname und Nachname',
      phone: 'Telefon',
      address: 'Adresse',
      code: 'Postleitzahl',
      pickDate: 'Abholdatum',
      pickOut: 'Abholzeit',
      licencePlate: 'Kennzeichen',
      vehicleModel: 'Fahrzeugmarke/-modell',
      vehicleColor: 'Fahrzeugfarbe',
      contactedBy: 'Kontakt via',
      tellContact: 'Sagen Sie uns, wie wir Sie am besten erreichen können',
      worker: 'Mitarbeiter',
      minAmountDelivery: 'Mindestbestellwert für Catering-Lieferung',
      minAmountPickUp: 'Mindestbestellwert für Catering-Abholung'
    },
    reservation: {
      availability: 'Wöchentliche Reservierungszeiten',
      reservations: 'Reservierungen',
      reservationDetail: 'Reservierungsdetails',
      create: 'Neue Reservierung',
      reservationDate: 'Reservierungsdatum',
      reservationHour: 'Reservierungsuhrzeit',
      timezone: 'Zeitzone',
      peoples: 'Personen',
      serviceTime: 'Voraussichtliche Servicezeit',
      reason: 'Anlass',
      find: 'Nach einer Reservierung suchen',
      enterCode: 'Code eingeben',
      yoursReservations: 'Reservierungen',
      code: 'Code',
      completeDateReservacion: 'Datum',
      notcodefind: 'Keine Reservierung mit diesem Code gefunden',
      state0: 'Anfrage',
      state1: 'Genehmigt',
      state2: 'Vorgeschlagenes Datum / Uhrzeit',
      state3: 'Abgelehnt',
      state4: 'Bestätigt',
      state5: 'Storniert',
      state6: 'Geschlossen',
      Monday: 'Montag',
      Tuesday: 'Dienstag',
      Wednesday: 'Mittwoch',
      Thursday: 'Donnerstag',
      Friday: 'Freitag',
      Saturday: 'Samstag',
      Sunday: 'Sonntag',
      all: 'Alle',
      restaurantHour: 'Öffnungszeiten',
      open: 'Geöffnet',
      close: 'Jetzt schließen, zur Seite gehen',
      errorHourCaterin: 'Catering-Zeit für ',
      errorHour: 'Reservierungszeit für ',
      errorHour2: ' ist von ',
      discount: 'Rabatt',
      orderCloseToDiscount: 'Diese Reservierung ist geschlossen und dieser Angebotspreis kann nicht verwendet werden.',
      subtotalNotForDiscount: 'Dieser Angebotspreis kann nicht verwendet werden, da er höher als der Zwischensumme ist.',
      notDiscountToApply: 'Kein Rabatt anwendbar',
      restaurantNotes: 'Geschäftsnotiz',
      quotationMessage1: 'Unser Vorauszahlungspreis für das Abendessen beträgt ',
      quotationMessage2: 'und dieser Betrag wird von Ihrer Bestellung abgezogen, wenn Sie bei uns bestellen. ',
      dinnerPrePayment: 'Vorauszahlung für Abendessen',
      timeToReserve: 'Dauer in Minuten ',
      available: 'Verfügbarkeit',
      notAvailable: 'Nicht verfügbar',
      deposit: 'Reservierungsanzahlung',
      seatsAvailable: ' Sitzplätze verfügbar',
      guestLocation: 'Wählen Sie den Standort aller Gäste aus',
      notGuestAvaibility: 'Es gibt keine Verfügbarkeit für alle Ihre Gäste',
      selectStaff: 'Mitarbeiter auswählen'
    },
    order: {
      item: 'Artikel',
      description: 'Beschreibung',
      quantity: 'Menge',
      taxable: 'Steuerpflichtig?',
      amount: 'Betrag',
      tip: 'Trinkgeld',
      discount: 'Rabatt',
      creditCardFee: 'Kreditkartengebühr',
      shipping: 'Versand',
      trackShipping: 'Verfolgen Sie den Versand',
      packagesManagement: 'Paketverwaltung',
      tax: 'Steuer',
      deposit: 'Anzahlung',
      pendingAcceptance: 'Ausstehende Annahme',
      accepted: 'Angenommen',
      prepare: 'Zubereitet',
      email: 'E-Mail',
      phone: 'Telefon',
      goBack: 'Zurück',
      orderDetail: 'Bestelldetails',
      quoteDetail: 'Angebotsdetails',
      convertInvoice: 'In Rechnung umwandeln',
      aceptQuote: 'Angebot annehmen',
      productServicesUpdated: 'Produkte/Dienstleistungen aktualisiert',
      payInvoive: 'Rechnung bezahlen',
      invoiceDetail: 'Rechnungsdetails',
      invoiceNumber: 'Rechnungsnr.',
      invoiceTerm: 'Bedingungen',
      invoicePayed: 'Ihre Rechnung wurde bezahlt',
      shippingDate: 'Versanddatum',
      shippingVia: 'Versandart',
      shippingTo: 'Versand an',
      shippingFrom: 'Versand von',
      shippingTrackingNumber: 'Sendungsnummer',
      client: 'Kunde',
      cart: 'Warenkorb',
      productsOrdered: 'Bestellte Produkte',
      products: 'Artikel',
      name: 'Name',
      cant: 'Menge',
      price: 'Preis',
      total: 'Gesamt',
      otherCharges: 'Zusätzliche Gebühren',
      quotationPayment: 'Angebotszahlung',
      cashPayment: 'Barzahlung',
      isTicket: 'Bestellung als Ticket öffnen',
      payAsTicket: 'Zahlung autorisieren ',
      sendInvoice: 'Rechnung senden ',
      saveAsTicket: 'Ticket speichern',
      checkPayment: 'Scheckzahlung',
      parcialPayment: 'Teilzahlung',
      quotationMessage1: 'Unsere Gebühr für Angebote beträgt ',
      quotationMessage2: 'und dieser Betrag wird von Ihrer Bestellung abgezogen, wenn Sie bei uns bestellen. ',
      pendingPayment: 'Ausstehende Zahlung',
      subtotal: 'Zwischensumme',
      taxe: 'Steuern',
      deliver: 'Lieferung',
      tip: 'Trinkgeld',
      notes: 'Notizen',
      payment: 'Zahlungsdetails',
      ccard: 'Kreditkarte',
      ccode: 'Kartenprüfnummer',
      payWithThisCardQuestion: 'Möchten Sie mit dieser Karte bezahlen?',
      cardEndingIn: 'Karte endet mit',
      yesPayNow: 'Ja, jetzt bezahlen',
      paymentSuccessful: 'Zahlung erfolgreich',
      paymentProcessed: 'Ihre Zahlung wurde erfolgreich verarbeitet',
      expcard: 'Ablaufdatum',
      dueDate: 'Fälligkeitsdatum',
      pay: 'Bezahlen',
      verify: 'Zahlung überprüfen',
      transictionTitle: 'Transaktionsstatus',
      transictionOk: 'Ihre Transaktion war erfolgreich',
      sendRequest: 'Anfrage senden',
      requestCatering: 'Anfrage gesendet. Der Geschäftsführer wird sich in Kürze bei Ihnen melden.',
      transictionError: 'Fehler bei der Zahlungsausführung',
      notValidCC: 'Ungültige Kreditkartennummer',
      yourOrders: 'Bestellungen ',
      yourTicket: 'Tickets ',
      seeAll: 'Alle Bestellungen anzeigen',
      orderState: ' Bestellstatus',
      cooker: ' Koch',
      type: 'Typ',
      state: 'Status',
      messageToast: 'Registrieren Sie sich einfach, um Ihre Bestellungen zu verfolgen und Ihre Bestellhistorie einzusehen. So einfach ist das!',
      messgForContact: 'Registrieren Sie sich einfach, um Ihre Bestellungen zu verfolgen und Ihre Bestellhistorie einzusehen. So einfach ist das!',
      messgForContactCatering: 'Sie müssen sich anmelden, um eine Catering-Bestellung zu erstellen',
      date: 'Datum',
      state0: 'Ausstehende Zahlung',
      state1: 'Bezahlt',
      state2: 'In der Küche',
      state3: 'Zubereitet',
      state4: 'Unterwegs',
      state5: 'Geliefert',
      state6: 'Storniert',
      state7: 'Ausstehende Überprüfung',
      state8: 'Catering genehmigt',
      state9: 'Angebot',
      state10: 'Bestellung abgeholt',
      state11: 'Verzögert',
      state12: 'Stornierung',
      state13: 'Erstattet',
      notOrder: 'Sie haben keine ausstehenden Bestellungen',
      transId: 'Transaktion',
      invoice: 'Rechnung',
      invoiceProposal: 'Rechnungsvorschlag',
      invoiceProposalUpdated: 'Rechnungsvorschlag aktualisiert',
      add: 'Hinzufügen',
      share: 'Teilen',
      remove: 'Entfernen',
      edit: 'Bearbeiten',
      cancelReason: 'Grund für die Stornierung',
      paymentMethod: 'Zahlungsmethode',
      orderFor: 'Bestellung für',
      other: 'Andere',
      noTip: 'Kein Trinkgeld',
      payed: 'Bezahlt',
      toPay: 'Zu zahlen',
      readyForPick: 'Sie erhalten eine SMS oder E-Mail, wenn Ihre Bestellung zur Abholung bereit ist.',
      location: 'Standort',
      hourToPickEstimated: 'Voraussichtliche Abholzeit',
      dateToPickEstimated: 'Voraussichtliches Abholdatum',
      routingNumber: 'Bankleitzahl',
      accountNumber: 'Kontonummer',
      bankName: 'Bankname',
      badroutingNumber: 'Falsche Bankleitzahl',
      eventName: 'Veranstaltungsname',
      guessNumber: 'Anzahl der Gäste',
      eventDate: 'Veranstaltungsdatum',
      messageDevice: 'Bitte kontaktieren Sie den iMenuApps®-Support unter 973-969-1909 oder support@solutionsforsuccess.net, um ein Gerät hinzuzufügen',
      eventStartHour: 'Veranstaltungsbeginn',
      eventEndHour: 'Veranstaltungsende',
      warningProductsTheOrderToCatering: 'Sie versuchen, einen Artikel hinzuzufügen, der NICHT zum Catering-Service gehört. Wenn Sie fortfahren, verlieren Sie die zuvor hinzugefügten Artikel. ',
      warningProductsTheCateringToOrder: 'Sie versuchen, einen Artikel aus dem Catering-Service hinzuzufügen. Wenn Sie fortfahren, verlieren Sie die zuvor hinzugefügten Artikel. ',
      clientInfo: 'Kundeninformation',
      orderType: 'Bestellart',
      paymentByCard: 'Mit Kreditkarte bezahlen',
      totalForPay: 'Gesamt zu zahlen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      postalCode: 'Postleitzahl',
      addressLine1: 'Adresse',
      updateTicket: 'Ticket aktualisieren',
      closeTicket: 'Ticket schließen',
      closed: 'Geschlossen',
      requiredCustomer: 'Kundendaten',
      requiredOrderType: 'Bestellart',
      culumnNumber: 'Anzahl der Spalten in der Zeile'
    },
    tooltips: {
      addOrder: 'Hinzufügen',
      printOrder: 'Drucken',
      forward: 'Weiterleiten',
      reOrder: 'Neu bestellen',
      refreshOrder: 'Aktualisieren',
      refreshCaptcha: 'Captcha aktualisieren',
      deleteOrder: 'Entfernen',
      readyProduct: 'Fertig',
      printRes: 'Drucken',
      shareLocation: 'Standort teilen',
      closeTicket: 'Schließen',
      editTicket: 'Bearbeiten',
      loadInfo: 'Ihre Daten werden geladen',
      loadRestaurant: 'Wird geladen...',
      getToRestaurant: 'Klicken Sie hier, wenn Sie am Geschäftsort angekommen sind',
      carInRestaurant: 'Das Auto ist am Geschäft angekommen',
      carArrivedInfo: 'Vielen Dank, dass Sie uns mitgeteilt haben, dass Ihr Auto angekommen ist',
      errorRestaurantOffline: 'Dieses Geschäft ist für die Öffentlichkeit nicht sichtbar',
      deliveryPayment: 'Lieferzahlung'
    },
    payment: {
      splitPayment: 'Geteilte Zahlung',
      splitIn: 'Aufteilen in',
      splitMss: 'Die zu zahlenden Beträge müssen den Gesamtbetrag der Bestellung decken. Keine Zahlung kann 0 sein.',
      splitPay: 'Zahlung #',
      splitToPay: 'Zahlen',
      splitPayed: 'Bezahlt',
      tjtPayment: 'Karte',
      creditPayment: 'Kredit',
      devicePayment: 'Gerät',
      idtechPayment: 'Moto/Swipe',
      swipePayment: 'Swipe',
      cashPayment: 'Bar',
      hcaPayment: 'ACH',
      housePayment: 'Hauskonto',
      checkPayment: 'Scheck',
      sharePayment: 'Geteilte Zahlung',
      qrPayment: 'QR-Zahlung',
      verifyMss: 'Nachdem Sie wissen, dass Ihre Zahlung getätigt wurde, überprüfen Sie die Zahlung, um die Bestellung zu speichern, oder brechen Sie ab, um diese Zahlung nicht fortzusetzen.',
      doingPayment: 'Zahlung wird durchgeführt',
      authorizingPayment: 'Zahlung wird autorisiert',
      insuficientFunds: 'Unzureichende Mittel',
      quoteExpired: 'Entschuldigung. Die Zeit für dieses Angebot ist abgelaufen',
      quoteChanged: 'Das Angebot wurde geändert und befindet sich im Status',
      quoteAcepted: 'Das Angebot wurde angenommen',
      goodPayment: 'Bezahlt',
      shareText1: ' hat einen Zahlungslink für die in unserem Geschäft aufgegebene Essensbestellung geteilt ',
      shareText1a: ' hat einen Zahlungslink für die in unserem Geschäft getätigte Reservierung geteilt ',
      shareText2: '. Bitte folgen Sie dem Link unten, um die Zahlung vorzunehmen. Vielen Dank!'
    },
    createNew: {
      businessTemplate: 'Geschäftsvorlage',
      restaurantName: 'Geschäftsname',
      restaurantAddres: 'Geschäftsadresse',
      restaurantPhone: 'Geschäftstelefon',
      restaurantEmail: 'Geschäfts-E-Mail',
      restaurantZipcode: 'Geschäfts-Postleitzahl',
      restaurantWeb: 'Geschäftswebsite',
      restaurantFax: 'Geschäfts-Fax',
      merchantName: 'Händlervorname',
      merchantLastName: 'Händlernachname',
      merchantAddres: 'Händleradresse',
      merchantZipcode: 'Postleitzahl',
      merchantPhone: 'Händlertelefonnummer',
      merchantEmail: 'Händler-E-Mail',
      merchantClerk: 'Benutzer-PIN (1 - 99999)',
      createTitle: 'Neues Geschäft in iMenuApps® erstellen',
      dataRestaurant: 'Geschäftsdetails',
      dataMercahnt: 'Händlerdaten',
      restaurants: 'Geschäfte',
      createdMessage: 'Das Geschäft wurde erfolgreich erstellt. Sie erhalten eine E-Mail mit dem Passwort für den Zugriff auf die Anwendung.',
      clerkToLong: 'PIN-Wert überschritten, maximal 99999 erlaubt',
      clerkNotValid: 'Ungültige PIN',
      reciveSubscription: 'Sie möchten Benachrichtigungen von erhalten',
      activateSubscription: 'Sie möchten Benachrichtigungen für aktivieren',
      saving: 'Geschäft wird gespeichert',
      recordSaving: 'Wird gespeichert',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      restaurantType: 'Geschäftsart',
      template: 'Vorlage',
      chooseBusinessTemplate: 'Geschäftsvorlage auswählen',
      select: 'Auswählen',
      temrsAndCondition: 'Geschäftsbedingungen',
      trialDate: '-Tage Testversion',
      trialMss: '14 Tage testen',
      business: 'Geschäft',
      reservation: 'Reservierung'
    },
    unsubscribe: {
      title: 'Abmelden',
      email: 'E-Mail',
      unsubscribeOk: 'Ihre E-Mail wurde erfolgreich abgemeldet',
      unsubscribeFail: 'Fehler. E-Mail nicht gefunden',
      restaurantFail: 'Geschäft nicht gefunden'
    },
    specialsPrice: {
      titles: 'Sonderpreise',
      title: 'Sonderpreis',
      name: 'Name',
      type: 'Typ',
      amount: 'Betrag',
      for: 'Für',
      apply: 'Anwenden',
      active: 'Aktiv',
      repite: 'Wiederholen',
      oneStarDate: 'Startdatum und -uhrzeit',
      oneEndDate: 'Enddatum und -uhrzeit',
      weekStarDate: 'Startzeit',
      weekEndDate: 'Endzeit',
      monthStardDat: 'Tag des Monats',
      annualStartDat: 'Monat und Tag des Jahres',
      activeRule: 'Es wird jeweils nur eine Regel angewendet. Die erste aktivierte Regel hat Vorrang.'
    },
    credit: {
      state0: 'Angefragt',
      state1: 'Angenommen',
      state2: 'Storniert',
      state3: 'Geschlossen',
      yourCredit: 'Ihre Guthaben',
      amount: 'Guthabenbetrag',
      debt: 'Schulden',
      createDate: 'Erstellungsdatum',
      active: 'Aktiv',
      dateFrom: 'Startdatum',
      dateTo: 'Enddatum',
      paymentDate: 'Zahlungsdatum',
      state: 'Status',
      pendingPay: 'Ausstehende Zahlung',
      payed: 'Bezahlt',
      creditpayed: 'Guthaben bezahlt',
      mssPay1: 'Der Kunde ',
      mssPay2: 'hat eine Guthabenzahlung getätigt ',
      mssPay3: 'in Höhe von '
    }
  }
}
